export const portsData = [
    {
        portCode: "AUMEL",
        portName: "Melbourne",
        state: "Victoria",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "CNSZX",
        portName: "Shenzhen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CAZUM",
        portName: "Churchill Falls",
        state: "Newfoundland",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNSHA",
        portName: "Shanghai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBLHR",
        portName: "Heathrow Apt/London",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USLAX",
        portName: "Los Angeles",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ZADUR",
        portName: "Durban",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "USSDF",
        portName: "Smiths Creek",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MTMLA",
        portName: "Malta (Valletta)",
        state: null,
        countryCode: "MT",
        countryName: "Malta",
    },
    {
        portCode: "USLMS",
        portName: "Louisville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLOS",
        portName: "Louisville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TWKHH",
        portName: "Kaohsiung",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "USIAH",
        portName: "Georg Bush Int'l Airport",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCFE",
        portName: "Chesterfield",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMDW",
        portName: "Midway",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNFUO",
        portName: "Foshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNZUH",
        portName: "Zhuhai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSZV",
        portName: "Suzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBTBL",
        portName: "St Albans",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CHBSL",
        portName: "Basel",
        state: null,
        countryCode: "CH",
        countryName: "Switzerland",
    },
    {
        portCode: "CNLNJ",
        portName: "Lincang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USBQK",
        portName: "Bunkie",
        state: "Louisiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMEM",
        portName: "Memphis",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MXMEX",
        portName: "Mexico City",
        state: "Mexico City",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "CNSAD",
        portName: "Shandong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSZP",
        portName: "Shenzhen Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USLGA",
        portName: "New York / La Guardia Apt",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFOA",
        portName: "Florida",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPHX",
        portName: "Phoenix",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KRSEL",
        portName: "Seoul",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "CNCGO",
        portName: "Zhengzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USSEA",
        portName: "Seattle",
        state: "Washington",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "VNDAD",
        portName: "Da Nang",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "FRBOD",
        portName: "Bordeaux",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USCLE",
        portName: "Cleveland",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSAN",
        portName: "San Diego",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUSYD",
        portName: "Sydney",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "INMAA",
        portName: "Chennai (ex Madras)",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "CNTNA",
        portName: "Jinan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "RUSVO",
        portName: "Sheremetyevo Apt/Moscow",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "GBMAN",
        portName: "Manchester",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CAYHM",
        portName: "Hamilton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNJHA",
        portName: "Jinhua",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "AUMOV",
        portName: "Moranbah",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "INMOR",
        portName: "Moradabad",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "JPNRT",
        portName: "Narita Apt/Tokyo",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CNQZJ",
        portName: "Quanzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CACST",
        portName: "Chester",
        state: "Nova Scotia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "AZGYD",
        portName: "Baku Heydar Aliyev Int'l Apt",
        state: null,
        countryCode: "AZ",
        countryName: "Azerbaijan",
    },
    {
        portCode: "KRICN",
        portName: "Incheon Intl Apt/Seoul",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "USTKE",
        portName: "Tenakee Springs",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CLSCL",
        portName: "Santiago",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "CACXH",
        portName: "Vancouver Coal Harbour SPB",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USCHA",
        portName: "Chattanooga",
        state: "Tennessee",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCB9",
        portName: "Columbus",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHZT",
        portName: "Hazelton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USENW",
        portName: "Kenosha",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITBGY",
        portName: "Milan Bergamo/Orio al Serio Apt",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USPNS",
        portName: "Pensacola",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNTHQ",
        portName: "Tianshui",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "INICD",
        portName: "New Delhi",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "UAODS",
        portName: "Odessa",
        state: null,
        countryCode: "UA",
        countryName: "Ukraine",
    },
    {
        portCode: "CNFOS",
        portName: "Foshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "SBMUA",
        portName: "Munda; New Georgia",
        state: null,
        countryCode: "SB",
        countryName: "Solomon Islands",
    },
    {
        portCode: "INMUN",
        portName: "Mundra",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "ESBCN",
        portName: "Barcelona",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CNXIY",
        portName: "Xi'an",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "AFQAM",
        portName: "Qasim",
        state: null,
        countryCode: "AF",
        countryName: "Afghanistan",
    },
    {
        portCode: "CNYOU",
        portName: "Yuyao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITBLQ",
        portName: "Bologna",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DESTR",
        portName: "Stuttgart",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CANDV",
        portName: "New Denver",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBEMA",
        portName: "East Midlands Apt",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "IEDUB",
        portName: "Dublin",
        state: null,
        countryCode: "IE",
        countryName: "Ireland",
    },
    {
        portCode: "DEBER",
        portName: "Berlin",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "TRMER",
        portName: "Mersin",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "GBLTN",
        portName: "Luton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNHYN",
        portName: "Huangyan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNDGG",
        portName: "Dongguan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "JPNKM",
        portName: "Nakama; Okinawa",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CNRIA",
        portName: "Ruian",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNYZH",
        portName: "Yangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CAMSA",
        portName: "Muskrat Dam",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYTZ",
        portName: "Toronto City Centre Apt",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "PLGDY",
        portName: "Gdynia",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "CAXPN",
        portName: "Brampton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USCOS",
        portName: "Colorado Springs",
        state: "Colorado",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ILSDV",
        portName: "Tel Aviv Yafo Sde Dov",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USFLL",
        portName: "Fort Lauderdale",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "LKCMB",
        portName: "Colombo",
        state: null,
        countryCode: "LK",
        countryName: "Sri Lanka",
    },
    {
        portCode: "USERU",
        portName: "East Rutherford",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAYHZ",
        portName: "Halifax Apt",
        state: "Nova Scotia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYTO",
        portName: "Toronto",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNYCU",
        portName: "Guangong Apt/Yuncheng",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USSHR",
        portName: "Sheridan",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOHB",
        portName: "Ohio",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBHFX",
        portName: "Halifax",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "FRSS2",
        portName: "St Saturnin",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "GBCBR",
        portName: "Colnbrook",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USGYR",
        portName: "Goodyear",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNGAS",
        portName: "Gaosha",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCKG",
        portName: "Chongqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHFE",
        portName: "Hefei",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CIABJ",
        portName: "Abidjan",
        state: null,
        countryCode: "CI",
        countryName: "Cote d'Ivoire",
    },
    {
        portCode: "ATINN",
        portName: "Innsbruck",
        state: null,
        countryCode: "AT",
        countryName: "Austria",
    },
    {
        portCode: "AUAAB",
        portName: "Arrabury",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "CLLSQ",
        portName: "Los Angeles (Chile)",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "CNSGP",
        portName: "Shanghai Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GRATH",
        portName: "Athinai",
        state: null,
        countryCode: "GR",
        countryName: "Greece",
    },
    {
        portCode: "USRLO",
        portName: "Rialto",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAHN",
        portName: "Athens",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEDTM",
        portName: "Dortmund",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USHAM",
        portName: "Hamburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEHAM",
        portName: "Hamburg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USDET",
        portName: "Detroit",
        state: "Michigan",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PFAAA",
        portName: "Anaa",
        state: null,
        countryCode: "PF",
        countryName: "French Polynesia",
    },
    {
        portCode: "CNCZX",
        portName: "Changzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITROM",
        portName: "Roma",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "ITFCO",
        portName: "Fiumicino",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USLUI",
        portName: "Louisville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPNGO",
        portName: "Nagoya; Aichi",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "ZAZBR",
        portName: "Felixton",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "CNTGO",
        portName: "Tongliao Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CAYMF",
        portName: "Montagne Harbor",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USJOT",
        portName: "Joliet",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USUYU",
        portName: "Staten Island",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIED",
        portName: "Springfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRTH",
        portName: "Rutherford",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INCJB",
        portName: "Coimbatore",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "CNLLF",
        portName: "Lingling Apt/Yongzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMCI",
        portName: "Kansas City Apt",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNCIV",
        portName: "Civet / Guandong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USIAD",
        portName: "Dulles Int Apt/Washington",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DE225",
        portName: "Braschwitz",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USLAS",
        portName: "Las Vegas",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNWEF",
        portName: "Weifang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHJJ",
        portName: "Zhijiang Apt/Huaihua",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USRDO",
        portName: "Rancho Dominguez",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMV4",
        portName: "Moreno Valley",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHKS",
        portName: "South Hackensack/New Jersey",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "VNHAN",
        portName: "Hanoi",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USSA8",
        portName: "Savannah",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USKSJ",
        portName: "Kansas",
        state: "Kentucky",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCMH",
        portName: "Columbus",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEDUS",
        portName: "Dusseldorf",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNBJS",
        portName: "Beijing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "NLAMS",
        portName: "Amsterdam",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "RUDME",
        portName: "Domodedovo Apt/Moscow",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "CNJUZ",
        portName: "Quzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ISAEY",
        portName: "Akureyri Apt",
        state: null,
        countryCode: "IS",
        countryName: "Iceland",
    },
    {
        portCode: "INBOM",
        portName: "Mumbai (ex Bombay)",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USSLC",
        portName: "Salt Lake City",
        state: "Utah",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRNTE",
        portName: "Nantes",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "NLEIN",
        portName: "Eindhoven",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "USJAX",
        portName: "Jacksonville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEFRA",
        portName: "Frankfurt am Main",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNJJN",
        portName: "Jinjiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "FRRNS",
        portName: "Rennes",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CNRUG",
        portName: "Rugao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USABE",
        portName: "Easton",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BEANR",
        portName: "Antwerpen",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "USSBY",
        portName: "Salisbury",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNFUJ",
        portName: "Fujin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "UYMVD",
        portName: "Montevideo",
        state: null,
        countryCode: "UY",
        countryName: "Uruguay",
    },
    {
        portCode: "CNZZU",
        portName: "Zhangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "INTUT",
        portName: "Tuticorin",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "CNYKG",
        portName: "Yongkang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITRAN",
        portName: "Ravenna",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CNCOZ",
        portName: "Chaozhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ROBAY",
        portName: "Baia Mare",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "GBLON",
        portName: "London",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USCA2",
        portName: "California",
        state: "Maryland",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USONT",
        portName: "Ontario",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHBN",
        portName: "Hebron",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNZHA",
        portName: "Zhanjiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNGUT",
        portName: "Guangdong Terminal",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNWNZ",
        portName: "Wenzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSHK",
        portName: "Shekou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USZJV",
        portName: "Maryland City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USDAL",
        portName: "Dallas",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INMBD",
        portName: "Pakwara (Moradabad)",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USBRO",
        portName: "Brownsville",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USDTW",
        portName: "Wayne County Apt/Detroit",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "UAIEV",
        portName: "Kiev",
        state: null,
        countryCode: "UA",
        countryName: "Ukraine",
    },
    {
        portCode: "GBFXT",
        portName: "Felixstowe",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNYIW",
        portName: "Yiwu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMSY",
        portName: "New Orleans",
        state: "Louisiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBFI",
        portName: "Bayfield",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNNTG",
        portName: "Nantong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "INNSA",
        portName: "Nhava Sheva",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USMHR",
        portName: "Morehead",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNHAK",
        portName: "Haikou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CAYYT",
        portName: "St John's",
        state: "Newfoundland",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USMDT",
        portName: "McDermott",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSTL",
        portName: "St Louis",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBSOU",
        portName: "Southampton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNYGG",
        portName: "Yanguan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "VNHPH",
        portName: "Haiphong",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USMSP",
        portName: "Minneapolis/St Paul Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZGT",
        portName: "Charleston Heights",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCLT",
        portName: "Charlotte",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGGG",
        portName: "Gladewater-Longview-Kilgore Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBBHX",
        portName: "Birmingham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USSMF",
        portName: "Smithfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBOS",
        portName: "Boston",
        state: "Massachusetts",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PKISB",
        portName: "Islamabad",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "USFMY",
        portName: "Fort Myers",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBEDI",
        portName: "Edinburgh",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "NAWDH",
        portName: "Windhoek",
        state: null,
        countryCode: "NA",
        countryName: "Namibia",
    },
    {
        portCode: "CNZHE",
        portName: "Zhenjiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ZACPT",
        portName: "Cape Town",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "GBLGW",
        portName: "Gatwick Apt/London",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USGSP",
        portName: "Greenville-Greer Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNFOC",
        portName: "Fuzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USORL",
        portName: "Orlando",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNDGM",
        portName: "Dongguan Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCIX",
        portName: "Cixi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USAUS",
        portName: "Austin",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNSJW",
        portName: "Shijiazhuang Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCSX",
        portName: "Changsha",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USDAC",
        portName: "Dallas",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNJMN",
        portName: "Jiangmen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USBNA",
        portName: "Nashville",
        state: "Tennessee",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PTLIS",
        portName: "Lisbon",
        state: null,
        countryCode: "PT",
        countryName: "Portugal",
    },
    {
        portCode: "CNPVG",
        portName: "Shanghai Pudong Apt.",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "AEDXB",
        portName: "Dubai",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "NLRTM",
        portName: "Rotterdam",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "INDEL",
        portName: "Delhi",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "UAKBP",
        portName: "Borispol Apt/Kiev",
        state: null,
        countryCode: "UA",
        countryName: "Ukraine",
    },
    {
        portCode: "NLDSE",
        portName: "Diessen",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "CNTSN",
        portName: "Tianjin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHGH",
        portName: "Hangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTAO",
        portName: "Qingdao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "SEARN",
        portName: "Arlanda Apt/Stockholm",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "CAYYZ",
        portName: "Toronto, Pearson Int'l Apt",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "NPKTM",
        portName: "Kathmandu",
        state: null,
        countryCode: "NP",
        countryName: "Nepal",
    },
    {
        portCode: "DEKAE",
        portName: "Karlsruhe",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBWBY",
        portName: "Wembley",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CORCH",
        portName: "Riohacha",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "THBKK",
        portName: "Bangkok",
        state: null,
        countryCode: "TH",
        countryName: "Thailand",
    },
    {
        portCode: "USDEN",
        portName: "Denver",
        state: "Colorado",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNSWA",
        portName: "Shantou, Jieyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USDLX",
        portName: "Dallas",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTPA",
        portName: "Tampa",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRIST",
        portName: "Istanbul",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "USNYC",
        portName: "New York",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ZMLUN",
        portName: "Lusaka",
        state: null,
        countryCode: "ZM",
        countryName: "Zambia",
    },
    {
        portCode: "CAYVR",
        portName: "Vancouver",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USRIC",
        portName: "Richmond",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTPE",
        portName: "Tempe",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUMPE",
        portName: "Tempe",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USNAS",
        portName: "Nashville",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRSW",
        portName: "Reisterstown",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KRPUS",
        portName: "Pusan",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "USORD",
        portName: "Chicago",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNXMN",
        portName: "Xiamen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USRNO",
        portName: "Reno",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPHL",
        portName: "Philadelphia",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNCAN",
        portName: "Guangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMKE",
        portName: "Milwaukee",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHOU",
        portName: "Houston",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEWR",
        portName: "Newark",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCAE",
        portName: "Columbia",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USATL",
        portName: "Atlanta",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PTOPO",
        portName: "Porto",
        state: null,
        countryCode: "PT",
        countryName: "Portugal",
    },
    {
        portCode: "USDFW",
        portName: "Dallas Int'l Airport",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOAK",
        portName: "Oakland",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TWKEL",
        portName: "Keelung (Chilung)",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "USMIO",
        portName: "Miami",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCHS",
        portName: "Charleston",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUTOR",
        portName: "Toronto",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "ZAJNB",
        portName: "Johannesburg",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "ESMAD",
        portName: "Madrid",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CHZRH",
        portName: "Zurich",
        state: null,
        countryCode: "CH",
        countryName: "Switzerland",
    },
    {
        portCode: "USJFK",
        portName: "New York / JFK Apt.",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBWI",
        portName: "Baltimore-Washington Int Apt",
        state: "Maryland",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNYTN",
        portName: "Yantian",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITCN2",
        portName: "Cenaia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USIND",
        portName: "Indianapolis",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCHI",
        portName: "Chicago",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMIA",
        portName: "Miami",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNPEK",
        portName: "Beijing Capital Apt.",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USPIR",
        portName: "Pierre",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUFEL",
        portName: "Felixstow",
        state: "South Australia",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "TWTPE",
        portName: "Taipei",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "MUMRU",
        portName: "Sir Seewoosagur Ramgoolam Int Apt",
        state: null,
        countryCode: "MU",
        countryName: "Mauritius",
    },
    {
        portCode: "USCVD",
        portName: "Cleveland",
        state: "Mississippi",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ILASH",
        portName: "Ashdod",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "CNNSA",
        portName: "Nansha",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNNGB",
        portName: "Ningbo",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GRPIR",
        portName: "Piraeus",
        state: null,
        countryCode: "GR",
        countryName: "Greece",
    },
    {
        portCode: "ILHFA",
        portName: "Haifa",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USCVG",
        portName: "Cincinnati",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ILTLV",
        portName: "Tel Aviv-Yafo",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USSFO",
        portName: "San Francisco",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "HKHKG",
        portName: "Hong Kong",
        state: null,
        countryCode: "HK",
        countryName: "Hong Kong",
    },
    {
        portCode: "CNWXS",
        portName: "Wuxi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USPDX",
        portName: "Portland",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTMC",
        portName: "Temecula",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTIW",
        portName: "Tacoma",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNJHG",
        portName: "Jinghong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITNAP",
        portName: "Napoli",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "GBFLX",
        portName: "Flixton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USBCT",
        portName: "Boca Raton",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPFSZ",
        portName: "Shizuoka Apt",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CATOR",
        portName: "Toronto",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "TRYAR",
        portName: "Yarimca",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "CAYAM",
        portName: "Sault Ste Marie",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "JPYOK",
        portName: "Yokohama",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CNDDG",
        portName: "Dandong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "MYKUL",
        portName: "Kuala Lumpur",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "CNMIG",
        portName: "Nanjiao Apt/Mianyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "VNSGN",
        portName: "Ho Chi Minh City",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "RUMCW",
        portName: "Moscow",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "CNKHN",
        portName: "Nanchang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNXMH",
        portName: "Haicang, Xiamen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USPXT",
        portName: "Phoenix Township",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPHKT",
        portName: "Hakata",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USFL4",
        portName: "Florida",
        state: "Massachusetts",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCRQ",
        portName: "Charlotte",
        state: "Michigan",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AURMA",
        portName: "Roma",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USCWA",
        portName: "Coldwater",
        state: "Michigan",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAPBH",
        portName: "Peterborough",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USALB",
        portName: "Albany",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TWTXG",
        portName: "Taichung",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "INJAI",
        portName: "Jaipur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "SGSIN",
        portName: "Singapore",
        state: null,
        countryCode: "SG",
        countryName: "Singapore",
    },
    {
        portCode: "USZOC",
        portName: "Oakland City",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNDLC",
        portName: "Dalian",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBFLE",
        portName: "Fleetwood",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "KIPHO",
        portName: "Phoenix Islands",
        state: null,
        countryCode: "KI",
        countryName: "Kiribati",
    },
    {
        portCode: "USRJJ",
        portName: "Richmond Beach",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLNK",
        portName: "Lincoln",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPTOY",
        portName: "Toyama",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CAYOW",
        portName: "Ottawa",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "LVRIX",
        portName: "Riga",
        state: null,
        countryCode: "LV",
        countryName: "Latvia",
    },
    {
        portCode: "HUBUD",
        portName: "Budapest",
        state: null,
        countryCode: "HU",
        countryName: "Hungary",
    },
    {
        portCode: "FRCDG",
        portName: "Charles de Gaulle Apt/Paris",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CNJZH",
        portName: "Jiaozhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITMXP",
        portName: "Malpensa Apt/Milano",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CNIQN",
        portName: "Xifengzhen Apt/Qingyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USTUL",
        portName: "Tulsa",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHNL",
        portName: "Honolulu",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPITM",
        portName: "Osaka Itami Airport",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "GBSWA",
        portName: "Swansea",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USSNA",
        portName: "Santa Ana",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ZAAAM",
        portName: "Mala Mala",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "USPAN",
        portName: "Patterson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNNAP",
        portName: "Nanping",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "DESXF",
        portName: "Berlin-Schonefeld Apt",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "BEBRU",
        portName: "Brussel (Bruxelles)",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "IDSUB",
        portName: "Surabaya",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USFLO",
        portName: "Florence",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLCK",
        portName: "Lockbourne",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEAU",
        portName: "Eau Claire",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PKKHI",
        portName: "Karachi",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "GBLCT",
        portName: "London City Airport",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USKCK",
        portName: "Kansas City",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNLYG",
        portName: "Lianyungang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHEB",
        portName: "Hebei",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USFRD",
        portName: "Friday Harbor",
        state: "Washington",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNDEZ",
        portName: "Dezhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CAYPR",
        portName: "Prince Rupert",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USHIO",
        portName: "Hillsboro",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INKTP",
        portName: "Kattupalli Port",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USCWH",
        portName: "Chatsworth",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBLPL",
        portName: "Liverpool",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "MXLEN",
        portName: "Leon",
        state: "Guanajuato",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "USBRX",
        portName: "Bronx / New York",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIDD",
        portName: "Middlesex",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFLE",
        portName: "Flemington",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNNKG",
        portName: "Nanjing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBSLL",
        portName: "Southall",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "KRKAN",
        portName: "Gwangyang",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "CNDSN",
        portName: "Dongsheng",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USICT",
        portName: "Wichita",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNJSU",
        portName: "Jiangsiu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USTXA",
        portName: "Texas",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DELEJ",
        portName: "Leipzig",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CAYYC",
        portName: "Calgary",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNBAD",
        portName: "Baoding",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "AUMRB",
        portName: "Moorebank/Sydney",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "FRAUM",
        portName: "Montreal",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "PHMNL",
        portName: "Manila",
        state: null,
        countryCode: "PH",
        countryName: "Philippines",
    },
    {
        portCode: "TWTSA",
        portName: "Taipei Sung Shan Apt",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "TWTNN",
        portName: "Tainan",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "CNDYG",
        portName: "Zhangjiajie",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USANC",
        portName: "Anchorage",
        state: "Alaska",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BDDAC",
        portName: "Dhaka",
        state: null,
        countryCode: "BD",
        countryName: "Bangladesh",
    },
    {
        portCode: "USMCO",
        portName: "McCook",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NZTRG",
        portName: "Tauranga",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "USLGB",
        portName: "Long Beach",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNHIS",
        portName: "Hengshui",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCTU",
        portName: "Chengdu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "INCCU",
        portName: "Kolkata (ex Calcutta)",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "VNTOT",
        portName: "Cai Mep",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USBLD",
        portName: "Boulder City",
        state: "Nevada",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KGFRU",
        portName: "Bishkek (ex Frunze)",
        state: null,
        countryCode: "KG",
        countryName: "Kyrgyzstan",
    },
    {
        portCode: "CAYUL",
        portName: "Montreal-Dorval Apt",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNWUS",
        portName: "Wusong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "THCNX",
        portName: "Chiang Mai",
        state: null,
        countryCode: "TH",
        countryName: "Thailand",
    },
    {
        portCode: "PLWAW",
        portName: "Warszawa",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "GBHMS",
        portName: "Hampstead",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBSWU",
        portName: "South Warnborough",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "SKBTS",
        portName: "Bratislava",
        state: null,
        countryCode: "SK",
        countryName: "Slovakia",
    },
    {
        portCode: "CYLCA",
        portName: "Larnaca",
        state: null,
        countryCode: "CY",
        countryName: "Cyprus",
    },
    {
        portCode: "ROBBU",
        portName: "Bucuresti-Baneasa Apt",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "USCZE",
        portName: "Corona",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFAT",
        portName: "Fresno",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "EETLL",
        portName: "Tallinn",
        state: null,
        countryCode: "EE",
        countryName: "Estonia",
    },
    {
        portCode: "BRAAX",
        portName: "Araxa",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "CNNNG",
        portName: "Nanning",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "DEMUC",
        portName: "Munchen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "BRCWB",
        portName: "Curitiba",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRGRU",
        portName: "Sao Paulo, Guarulhos Int'l Apt",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "PKSKT",
        portName: "Sialkot",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "COBOG",
        portName: "Bogota",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "INBLR",
        portName: "Bangalore",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "CAMTR",
        portName: "Montreal",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "ESVLC",
        portName: "Valencia",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "GBCVT",
        portName: "Coventry",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "AOLAD",
        portName: "Luanda",
        state: null,
        countryCode: "AO",
        countryName: "Angola",
    },
    {
        portCode: "CADEL",
        portName: "Delta",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "VCBQU",
        portName: "Port Elizabeth; Bequia",
        state: null,
        countryCode: "VC",
        countryName: "Saint Vincent and the Grenadines",
    },
    {
        portCode: "USJAC",
        portName: "Jackson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITGOA",
        portName: "Genoa",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USFSM",
        portName: "Fort Smith",
        state: "Arkansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USACY",
        portName: "American Canyon",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SBNNB",
        portName: "Santa Ana",
        state: null,
        countryCode: "SB",
        countryName: "Solomon Islands",
    },
    {
        portCode: "UGULU",
        portName: "Gulu",
        state: null,
        countryCode: "UG",
        countryName: "Uganda",
    },
    {
        portCode: "USBIS",
        portName: "Bismarck",
        state: "North Dakota",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITMIL",
        portName: "Milano",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "MACMN",
        portName: "Casablanca Mohammed V Apt",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "HRZAG",
        portName: "Zagreb",
        state: null,
        countryCode: "HR",
        countryName: "Croatia",
    },
    {
        portCode: "USSGU",
        portName: "St George",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBHM",
        portName: "Birmingham",
        state: "Alabama",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOTH",
        portName: "North Bend",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDMES",
        portName: "Medan; Sumatra",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USABQ",
        portName: "Albuquerque",
        state: "New Mexico",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTUP",
        portName: "Tupelo",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CZXUY",
        portName: "Prague-Vinohrady",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "DENSS",
        portName: "Neuss",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "ITTVG",
        portName: "Treviglio",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "MACAS",
        portName: "Casablanca",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "LULUX",
        portName: "Luxembourg",
        state: null,
        countryCode: "LU",
        countryName: "Luxembourg",
    },
    {
        portCode: "INTIR",
        portName: "Tirupati",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "PELIM",
        portName: "Lima",
        state: null,
        countryCode: "PE",
        countryName: "Peru",
    },
    {
        portCode: "USSAT",
        portName: "San Antonio",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAUZ",
        portName: "Aurora",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITFLR",
        portName: "Firenze",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USDWZ",
        portName: "Downey",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLIT",
        portName: "Little Rock",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITTRN",
        portName: "Torino",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "INNMB",
        portName: "Navi Mumbai",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USPBG",
        portName: "Pittsburg",
        state: "Kansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ATVIE",
        portName: "Vienna",
        state: null,
        countryCode: "AT",
        countryName: "Austria",
    },
    {
        portCode: "IDDPS",
        portName: "Denpasar; Bali",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "DZBJA",
        portName: "Bejaia (ex Bougie)",
        state: null,
        countryCode: "DZ",
        countryName: "Algeria",
    },
    {
        portCode: "USORF",
        portName: "Norfolk",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHZL",
        portName: "Hazleton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEGGO",
        portName: "Langgons",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBPET",
        portName: "Peterborough",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNSUD",
        portName: "Shunde",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USDCA",
        portName: "National Apt/Washington",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNROQ",
        portName: "Rongqi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "JPAKJ",
        portName: "Asahikawa",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USBZB",
        portName: "Baltimore",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INBHU",
        portName: "Bhavnagar",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "CHGVA",
        portName: "Geneve",
        state: null,
        countryCode: "CH",
        countryName: "Switzerland",
    },
    {
        portCode: "SESTO",
        portName: "Stockholm",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "BGSOF",
        portName: "Sofia",
        state: null,
        countryCode: "BG",
        countryName: "Bulgaria",
    },
    {
        portCode: "CNSHP",
        portName: "Qinhuangdao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USTYS",
        portName: "Knoxville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CRPMZ",
        portName: "Palmar",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "ITVCE",
        portName: "Venezia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USTOL",
        portName: "Toledo",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KZALA",
        portName: "Almaty",
        state: null,
        countryCode: "KZ",
        countryName: "Kazakhstan",
    },
    {
        portCode: "NZWLG",
        portName: "Wellington",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "AUBDB",
        portName: "Bundaberg",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "CNAQG",
        portName: "Anqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITPSA",
        portName: "Pisa",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DENUE",
        portName: "Nurnberg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "VNCLI",
        portName: "Cat Lai",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "SIANH",
        portName: "Anhovo",
        state: null,
        countryCode: "SI",
        countryName: "Slovenia",
    },
    {
        portCode: "SIKOP",
        portName: "Koper",
        state: null,
        countryCode: "SI",
        countryName: "Slovenia",
    },
    {
        portCode: "USGHG",
        portName: "Gothenburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NLHEJ",
        portName: "Heijen",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "MFSFG",
        portName: "St Martin",
        state: null,
        countryCode: "MF",
        countryName: "Saint Martin",
    },
    {
        portCode: "CNWUZ",
        portName: "Wuzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USTEB",
        portName: "Teterboro",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AREZE",
        portName: "Buenos Aires",
        state: null,
        countryCode: "AR",
        countryName: "Argentina",
    },
    {
        portCode: "PECLL",
        portName: "Callao",
        state: null,
        countryCode: "PE",
        countryName: "Peru",
    },
    {
        portCode: "DEAPO",
        portName: "Apolda",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBHOK",
        portName: "Hook",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "RUOMS",
        portName: "Omsk",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "JPKIX",
        portName: "Kansai Int Apt",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USGRB",
        portName: "Green Bay",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDJOG",
        portName: "Yogyakarta",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "CAQUE",
        portName: "Quebec",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBBRS",
        portName: "Bristol",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CAYPB",
        portName: "Port Alberni",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USTVC",
        portName: "Traverse City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNHUA",
        portName: "Huangpu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMOB",
        portName: "Mobile",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFLG",
        portName: "Flagstaff",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAEDM",
        portName: "Edmonton",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "DEPFO",
        portName: "Pforzheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "PLRWK",
        portName: "Radomysl Wielki",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "ESALC",
        portName: "Alicante",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USCXR",
        portName: "Closter/New Jersey",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTEA",
        portName: "Teaneck",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITSWK",
        portName: "MILAN SEGRATE",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USGRR",
        portName: "Grand Rapids",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJGC",
        portName: "Grove City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MTKAL",
        portName: "Kalkara",
        state: null,
        countryCode: "MT",
        countryName: "Malta",
    },
    {
        portCode: "USAUG",
        portName: "Augusta",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBDH",
        portName: "Bedford Heights",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USILM",
        portName: "Wilmington",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBVI",
        portName: "Breinigsville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITGEA",
        portName: "Gela",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "NOOSL",
        portName: "Oslo",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "USLFT",
        portName: "Lafayette",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITSPE",
        portName: "La Spezia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USEUG",
        portName: "Eugene",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNWUH",
        portName: "Wuhan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHEK",
        portName: "Heihe",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "PLMIK",
        portName: "Miko?ow",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "NGLOS",
        portName: "Lagos",
        state: null,
        countryCode: "NG",
        countryName: "Nigeria",
    },
    {
        portCode: "AMEVN",
        portName: "Yerevan",
        state: null,
        countryCode: "AM",
        countryName: "Armenia",
    },
    {
        portCode: "USSBT",
        portName: "San Bernardino",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USWHT",
        portName: "Wharton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFAY",
        portName: "Fayetteville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FIHEL",
        portName: "Helsingfors (Helsinki)",
        state: null,
        countryCode: "FI",
        countryName: "Finland",
    },
    {
        portCode: "USFRG",
        portName: "Farmingdale",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRLEH",
        portName: "Le Havre",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "AEAUH",
        portName: "Abu Dhabi",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "USSBA",
        portName: "Santa Barbara",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SILJU",
        portName: "Ljubljana",
        state: null,
        countryCode: "SI",
        countryName: "Slovenia",
    },
    {
        portCode: "USVEW",
        portName: "Westwood",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFSD",
        portName: "Sioux Falls",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DE226",
        portName: "Brasen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "NZAKL",
        portName: "Auckland",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "PKKYC",
        portName: "Karachi City",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "ESAGP",
        portName: "Malaga",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USKYE",
        portName: "Kearney",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITLIV",
        portName: "Livorno",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "AUPER",
        portName: "Perth",
        state: "Western Australia",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "CNFQG",
        portName: "Fuqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "AUBNE",
        portName: "Brisbane",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "BDCGP",
        portName: "Chittagong",
        state: null,
        countryCode: "BD",
        countryName: "Bangladesh",
    },
    {
        portCode: "ROCND",
        portName: "Constanta",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "DEBRV",
        portName: "Bremerhaven",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USNYF",
        portName: "Kearny",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNNNP",
        portName: "Nansha New Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "PHCEB",
        portName: "Cebu",
        state: null,
        countryCode: "PH",
        countryName: "Philippines",
    },
    {
        portCode: "USRDU",
        portName: "Durham-Raleigh Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USELP",
        portName: "El Paso",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NLSPL",
        portName: "Schiphol",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "USGEG",
        portName: "Spokane",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRKK",
        portName: "Ronkonkoma",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NOSIS",
        portName: "Sunde",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "CNCHG",
        portName: "Chenghai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "FRNCE",
        portName: "Nice",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "ITOGO",
        portName: "Ornago",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "ITBGO",
        portName: "Bergamo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "IDCGK",
        portName: "Soekarno-Hatta Apt/Jakarta",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USIDA",
        portName: "Idaho Falls",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRLS",
        portName: "Redlands",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USXDI",
        portName: "Brookshire",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBWOK",
        portName: "Wokingham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USABG",
        portName: "Abingdon",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGOI",
        portName: "Genoa",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBREY",
        portName: "Rugeley",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "AUABX",
        portName: "Albury",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USVGA",
        portName: "Virginia",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZFT",
        portName: "Illinois City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USQV2",
        portName: "Pennsylvania Furnace",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZMV",
        portName: "Melville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRRIG",
        portName: "Rio Grande",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "ITTYR",
        portName: "Trivolzio",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "KHREP",
        portName: "Siem Reap",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "USHSV",
        portName: "Huntsville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRSSZ",
        portName: "Santos",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "PAPTY",
        portName: "Panama; Ciudad de",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "USWRA",
        portName: "Warrington",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBWRN",
        portName: "Warrington",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "MYPKG",
        portName: "Port Kelang",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "USSPA",
        portName: "Spartanburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAPRA",
        portName: "Prince Albert",
        state: "Saskatchewan",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "ITBCR",
        portName: "Bagnolo Cremasco",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CNHZS",
        portName: "Heze",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "TWTYN",
        portName: "Taoyuan",
        state: null,
        countryCode: "TW",
        countryName: "Taiwan",
    },
    {
        portCode: "PKQCT",
        portName: "Qasim International Container Terminal/K",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "RUNYM",
        portName: "Nadym",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "OMSLL",
        portName: "Salalah",
        state: null,
        countryCode: "OM",
        countryName: "Oman",
    },
    {
        portCode: "GBACM",
        portName: "Altrincham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CAPRR",
        portName: "Prince Rupert",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "KRTAE",
        portName: "Daegu",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "CAYGK",
        portName: "Kingston",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBDRL",
        portName: "Darlington",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USGGO",
        portName: "Gouldsboro",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MYKLA",
        portName: "Klang",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "PLSZC",
        portName: "Szczecinek",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USGAC",
        portName: "Gardena",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGGA",
        portName: "Georgia",
        state: "Vermont",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOBE",
        portName: "Obetz",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCEJ",
        portName: "Coppell",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEDW",
        portName: "Edwardsville",
        state: "Kansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTHS",
        portName: "Thames Haven",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBTHE",
        portName: "Thame",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ARROS",
        portName: "Rosario",
        state: null,
        countryCode: "AR",
        countryName: "Argentina",
    },
    {
        portCode: "GBBLK",
        portName: "Blackpool",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USGNK",
        portName: "Great Neck",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMCH",
        portName: "McDonough",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BSNAS",
        portName: "Nassau",
        state: null,
        countryCode: "BS",
        countryName: "Bahamas",
    },
    {
        portCode: "INNHV",
        portName: "Nhave",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "SGXSP",
        portName: "Singapore Seletar Apt",
        state: null,
        countryCode: "SG",
        countryName: "Singapore",
    },
    {
        portCode: "CNGOM",
        portName: "Gaoming",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USPIE",
        portName: "St Petersburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CASUY",
        portName: "Surrey",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "INJDG",
        portName: "Jodhpur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USHWD",
        portName: "Hayward",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLOR",
        portName: "Lorain",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSFU",
        portName: "Spanish Fork",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAYWG",
        portName: "Winnipeg",
        state: "Manitoba",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBGLW",
        portName: "Glasgow",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ESLAX",
        portName: "Laxe",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "JPHHE",
        portName: "Hachinohe",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CAVAN",
        portName: "Vancouver",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBWOR",
        portName: "Workington",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "FRMRS",
        portName: "Marseille",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USDLT",
        portName: "Deltona",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRCEA",
        portName: "Cestas",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USW3C",
        portName: "Worcestar",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLGRK",
        portName: "Grodzisk Mazowiecki",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "PRSJU",
        portName: "San Juan",
        state: null,
        countryCode: "PR",
        countryName: "Puerto Rico",
    },
    {
        portCode: "CAHAL",
        portName: "Halifax",
        state: "Nova Scotia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USQCY",
        portName: "Quincy",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "RWKME",
        portName: "Kamembe",
        state: null,
        countryCode: "RW",
        countryName: "Rwanda",
    },
    {
        portCode: "GBMNC",
        portName: "Manchester",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USBTR",
        portName: "Baton Rouge",
        state: "Louisiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NLMST",
        portName: "Maastricht",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "USWLP",
        portName: "Walpole",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ETADD",
        portName: "Addis Ababa",
        state: null,
        countryCode: "ET",
        countryName: "Ethiopia",
    },
    {
        portCode: "MYJHB",
        portName: "Johor Bahru",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "CNSHE",
        portName: "Shenyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "PKPCT",
        portName: "Pakistan International Container Termina",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "ITCSM",
        portName: "Casalmaggiore",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "GBBLT",
        portName: "Bolton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ITCHI",
        portName: "Chioggia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "BELGG",
        portName: "Liege",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "CAJOL",
        portName: "Joliette",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "DOSTI",
        portName: "Santiago de los Caballeros",
        state: null,
        countryCode: "DO",
        countryName: "Dominican Republic",
    },
    {
        portCode: "AUMBH",
        portName: "Maryborough",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USLBN",
        portName: "Lebanon",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMAC",
        portName: "Macon",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCQE",
        portName: "Cranbury",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DOAZS",
        portName: "Samana International Apt",
        state: null,
        countryCode: "DO",
        countryName: "Dominican Republic",
    },
    {
        portCode: "DEBRE",
        portName: "Bremen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DZAAE",
        portName: "Annaba (ex Bone)",
        state: null,
        countryCode: "DZ",
        countryName: "Algeria",
    },
    {
        portCode: "TRIZM",
        portName: "Izmir",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "ITVRN",
        portName: "Verona",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USCPM",
        portName: "Compton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFJO",
        portName: "Fontana",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSIP",
        portName: "Saint Peter",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ESSVQ",
        portName: "Sevilla",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "JPTYO",
        portName: "Tokyo",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "DKCPH",
        portName: "Copenhagen",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "DECGN",
        portName: "Koln",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "ROARW",
        portName: "Arad",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "USCI7",
        portName: "Carlisle",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFAV",
        portName: "Fall River",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCCF",
        portName: "Concord",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSRT",
        portName: "Schertz",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIFI",
        portName: "Plainfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCB2",
        portName: "Clear Brook",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GTGUA",
        portName: "Guatemala City",
        state: null,
        countryCode: "GT",
        countryName: "Guatemala",
    },
    {
        portCode: "PLGPS",
        portName: "Grodzisk",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USP4T",
        portName: "St. Petersburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRMD",
        portName: "Redmond",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITCG6",
        portName: "Capergnanica",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USGNW",
        portName: "Greenwood",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRESY",
        portName: "Esenyurt",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "GBLGP",
        portName: "London Gateway Port",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USSCK",
        portName: "Stockton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFDT",
        portName: "Ferndale",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITLIN",
        portName: "Linate Apt/Milano",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USFEZ",
        portName: "Santa Fe",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPMQ",
        portName: "Paramount",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBDSE",
        portName: "Deeside",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "IEASD",
        portName: "Ashford",
        state: null,
        countryCode: "IE",
        countryName: "Ireland",
    },
    {
        portCode: "ESGEN",
        portName: "Gerena",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "ISREY",
        portName: "Reykjavik",
        state: null,
        countryCode: "IS",
        countryName: "Iceland",
    },
    {
        portCode: "JPHND",
        portName: "Haneda Apt/Tokyo",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USLVI",
        portName: "Livonia",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHCC",
        portName: "Hudson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHAP",
        portName: "Hauppauge",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRCU",
        portName: "Rancho Cucamonga",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AGANU",
        portName: "Antigua",
        state: null,
        countryCode: "AG",
        countryName: "Antigua and Barbuda",
    },
    {
        portCode: "GBABB",
        portName: "Abingdon",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "MOMFM",
        portName: "Macau",
        state: null,
        countryCode: "MO",
        countryName: "Macao",
    },
    {
        portCode: "USMNC",
        portName: "Michigan Center",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPSG",
        portName: "Petersburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USDAY",
        portName: "Dayton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "THLCH",
        portName: "Laem Chabang",
        state: null,
        countryCode: "TH",
        countryName: "Thailand",
    },
    {
        portCode: "ECESM",
        portName: "Esmeraldas",
        state: null,
        countryCode: "EC",
        countryName: "Ecuador",
    },
    {
        portCode: "CHLUG",
        portName: "Lugano",
        state: null,
        countryCode: "CH",
        countryName: "Switzerland",
    },
    {
        portCode: "USKOA",
        portName: "Coggon",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INHYD",
        portName: "Hyderabad",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GBCWL",
        portName: "Cardiff",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "QADOH",
        portName: "Doha",
        state: null,
        countryCode: "QA",
        countryName: "Qatar",
    },
    {
        portCode: "USAA2",
        portName: "Alabama Pt.",
        state: "Alabama",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITCRE",
        portName: "Cremona",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "KWKWI",
        portName: "Kuwait",
        state: null,
        countryCode: "KW",
        countryName: "Kuwait",
    },
    {
        portCode: "RSBEG",
        portName: "Belgrade (Beograd)",
        state: null,
        countryCode: "RS",
        countryName: "Serbia",
    },
    {
        portCode: "SENYO",
        portName: "Stockholm Skavsta Airport",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "CNBJO",
        portName: "Beijiao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBLIV",
        portName: "Liverpool",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USBGB",
        portName: "Burr Ridge",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSAV",
        portName: "Savannah",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DKAAL",
        portName: "Aalborg",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "USJEF",
        portName: "Jefferson City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BEZEE",
        portName: "Zeebrugge",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "USBEX",
        portName: "Bethlehem",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSSL",
        portName: "St Charles",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRER",
        portName: "Rensselaer",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPPO",
        portName: "Sparrows Point",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNQSE",
        portName: "Qingshuihe; Shenzhen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CACOQ",
        portName: "Coquitlam",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USGPV",
        portName: "Grapevine",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUGVP",
        portName: "Greenvale",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USGVP",
        portName: "Groveport",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITOEO",
        portName: "Offanengo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "GBDFR",
        portName: "Dunfermline",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USINU",
        portName: "Industry",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCHH",
        portName: "Channahon",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEMNI",
        portName: "Meiningen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBESX",
        portName: "Essex",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ESCND",
        portName: "Canada",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CARTB",
        portName: "Robert's Bank",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAMIS",
        portName: "Mississauga",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "FRGZX",
        portName: "Gardegan-Et-Tourtirac",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "INNAG",
        portName: "Nagpur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USPOI",
        portName: "Pontiac",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USKRN",
        portName: "Kernersville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOLV",
        portName: "Olive Branch",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLGU",
        portName: "Logan",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAUD",
        portName: "Auburndale",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMTA",
        portName: "Manteca",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZCW",
        portName: "Cromwell",
        state: "Connecticut",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEROU",
        portName: "Rodgau",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "AURED",
        portName: "Redfern",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USBAL",
        portName: "Baltimore",
        state: "Maryland",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAVP",
        portName: "Wilkes-Barre/Scranton Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSKE",
        portName: "Shakopee",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSAF",
        portName: "Santa Fe",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USDLH",
        portName: "Duluth",
        state: "Minnesota",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPUKB",
        portName: "Kobe",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USWEJ",
        portName: "West Jordan",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTFK",
        portName: "Trafford Park",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USSXG",
        portName: "Sumner",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USITL",
        portName: "Whiteland",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CLQCO",
        portName: "Quinchao",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "USLHS",
        portName: "Lithia Springs",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGSO",
        portName: "Greensboro-High Point Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USNBJ",
        portName: "New Brunswick",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMLU",
        portName: "Monroe",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRIF",
        portName: "Richfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIPS",
        portName: "Minneapolis",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "UAHRK",
        portName: "Kharkov",
        state: null,
        countryCode: "UA",
        countryName: "Ukraine",
    },
    {
        portCode: "KHPNH",
        portName: "Phnom Penh",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "CNYNT",
        portName: "Yantai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNYAT",
        portName: "Yantai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USINQ",
        portName: "Monroe",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USROU",
        portName: "Romulus",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CABLT",
        portName: "Bolton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "ESALG",
        portName: "Algeciras",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "ESTOL",
        portName: "Toledo",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USZAC",
        portName: "Alabama City",
        state: "Alabama",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLPOZ",
        portName: "Poznan",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "GBMME",
        portName: "Teesside",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USNTI",
        portName: "Northlake",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITGIT",
        portName: "Gioia Tauro",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USPOT",
        portName: "Pt Tampa",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USKET",
        portName: "Kent",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCS5",
        portName: "Chelsea",
        state: "Oklahoma",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USQPD",
        portName: "Poland",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USUJD",
        portName: "Folcroft",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CANIU",
        portName: "Nisku",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "PKBQM",
        portName: "Karachi-Muhammad Bin Qasim",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "MYXPQ",
        portName: "Port Klang (Ferry Port)",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "CASCB",
        portName: "Scarborough",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USCEK",
        portName: "Cerritos",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "THLKR",
        portName: "Lat Krabang",
        state: null,
        countryCode: "TH",
        countryName: "Thailand",
    },
    {
        portCode: "MYTPP",
        portName: "Tanjung Pelepas",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "ILETH",
        portName: "Elat (Eilath)",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "TNTUN",
        portName: "Tunis",
        state: null,
        countryCode: "TN",
        countryName: "Tunisia",
    },
    {
        portCode: "GBDVY",
        portName: "Daventry",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBBUY",
        portName: "Bury",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBHWW",
        portName: "Hawkwell",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USCLW",
        portName: "Clearwater",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "LTKLJ",
        portName: "Klaipeda",
        state: null,
        countryCode: "LT",
        countryName: "Lithuania",
    },
    {
        portCode: "CAYMQ",
        portName: "Montreal",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CZKLV",
        portName: "Karlovy Vary",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "FRFIE",
        portName: "Fontafie",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "LTVNO",
        portName: "Vilnius",
        state: null,
        countryCode: "LT",
        countryName: "Lithuania",
    },
    {
        portCode: "DEWVN",
        portName: "Wilhelmshaven",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "TRKMX",
        portName: "Kumport",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "DETXL",
        portName: "Berlin-Tegel Apt",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "FRPAR",
        portName: "Paris",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "DEHSG",
        portName: "Heroldsberg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MMRGN",
        portName: "Yangon",
        state: null,
        countryCode: "MM",
        countryName: "Myanmar",
    },
    {
        portCode: "BRNTR",
        portName: "Niteroi",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "MMMDL",
        portName: "Mandalay",
        state: null,
        countryCode: "MM",
        countryName: "Myanmar",
    },
    {
        portCode: "CAABH",
        portName: "Ashburn",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "PAONX",
        portName: "Colon",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "GBBED",
        portName: "Bedfont",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USMGW",
        portName: "Morgantown",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCNO",
        portName: "Chino",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AEJEA",
        portName: "Jebel Ali",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "USLDE",
        portName: "Linden",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRNVT",
        portName: "Navegantes",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "USPEF",
        portName: "Port Everglades",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAABR",
        portName: "Rocky View",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USOKC",
        portName: "Oklahoma City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRALI",
        portName: "Aliaga",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "CNYAN",
        portName: "Yangshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBTIL",
        portName: "Tilbury",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "SHASI",
        portName: "Georgetown",
        state: null,
        countryCode: "SH",
        countryName: "Saint Helena",
    },
    {
        portCode: "DE5BZ",
        portName: "Bobitz",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USHKA",
        portName: "Houston",
        state: "Alaska",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INKRI",
        portName: "Krishnapatnam",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GBSTN",
        portName: "Stansted Apt/London",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "FRLPE",
        portName: "La Pallice",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CAYEG",
        portName: "Edmonton Int Apt",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNXTI",
        portName: "Xingtai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USIAY",
        portName: "Italy",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PAMIT",
        portName: "Manzanillo",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "VNUIH",
        portName: "Qui Nhon",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USXNA",
        portName: "Sayreville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTYN",
        portName: "Tyne",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBQEW",
        portName: "Leicester",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNSXG",
        portName: "Shaoxing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "VNVUT",
        portName: "Vung Tau",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "BEROT",
        portName: "Rotem",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "GBDON",
        portName: "Doncaster",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "DERGM",
        portName: "Nuremberg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEGDH",
        portName: "Goldbach",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CUGER",
        portName: "Nueva Gerona",
        state: null,
        countryCode: "CU",
        countryName: "Cuba",
    },
    {
        portCode: "VNDVU",
        portName: "Dinh Vu Terminal",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "BYMSQ",
        portName: "Minsk",
        state: null,
        countryCode: "BY",
        countryName: "Belarus",
    },
    {
        portCode: "USHGR",
        portName: "Hagerstown",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEKLT",
        portName: "Kaiserslautern",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "RULED",
        portName: "Saint Petersburg (ex Leningrad)",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "INAMD",
        portName: "Ahmedabad",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GBDVR",
        portName: "Dover",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "BSFPO",
        portName: "Freeport, Grand Bahama",
        state: null,
        countryCode: "BS",
        countryName: "Bahamas",
    },
    {
        portCode: "TRYPO",
        portName: "Yilport",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "GBCMG",
        portName: "Cambridge",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "COCTG",
        portName: "Cartagena",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "USMT8",
        portName: "Montreal",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBGAT",
        portName: "Gateshead",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "TNRDS",
        portName: "Rades/Tunis",
        state: null,
        countryCode: "TN",
        countryName: "Tunisia",
    },
    {
        portCode: "PKLHE",
        portName: "Lahore",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "GBZBW",
        portName: "Leeds",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBBLS",
        portName: "Brightlingsea",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNZAP",
        portName: "Zhapu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBSSH",
        portName: "South Shields",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBCOA",
        portName: "Coalville",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "NLTLB",
        portName: "Tilburg",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "USYNR",
        portName: "Tyner",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NODON",
        portName: "Donna",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "DEHMY",
        portName: "Hammersbach",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNMWN",
        portName: "Mawan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "DE3BZ",
        portName: "Bobingen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEEIS",
        portName: "Eisenach",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "JPOSA",
        portName: "Osaka",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CNDCH",
        portName: "Dachang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTYN",
        portName: "Taiyuan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBRUG",
        portName: "Rugby",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USRFD",
        portName: "Rockford",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRDF",
        portName: "Redford",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITGEO",
        portName: "Gello",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DEHAR",
        portName: "Haiger",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "FRXNL",
        portName: "Nueil-sur-Layon",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CABC2",
        portName: "Bow City",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "TRABH",
        portName: "Basaksehir",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "DEFFO",
        portName: "Frankfurt/Oder",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MYPEN",
        portName: "Penang (Georgetown)",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "KHKOS",
        portName: "Sihanoukville",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "USNVD",
        portName: "Nevada",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "VNCMT",
        portName: "Cai Mep International Terminal",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USEEW",
        portName: "Englewood",
        state: "Tennessee",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USYLO",
        portName: "Logan Township",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSFD",
        portName: "South Plainfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBXQD",
        portName: "Bedford",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBBEF",
        portName: "Bedford",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USBBF",
        portName: "Burlington",
        state: "Massachusetts",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBCFD",
        portName: "Chelmsford",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBHIL",
        portName: "Hinckley",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "KRGMP",
        portName: "Gimpo",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "CNTXG",
        portName: "Tianjin, Xingang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USCRU",
        portName: "Carson",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHMJ",
        portName: "Harvey",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNCHQ",
        portName: "Chongqing Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "IDCBN",
        portName: "Cirebon (Tjeribon)",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USBUR",
        portName: "Burbank",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KRKUV",
        portName: "Gunsan",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "KRKWA",
        portName: "Kwangyang",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "USABI",
        portName: "Abilene",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PTSIE",
        portName: "Sines",
        state: null,
        countryCode: "PT",
        countryName: "Portugal",
    },
    {
        portCode: "GBPGN",
        portName: "Paignton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBWIH",
        portName: "Witham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNDCB",
        portName: "Da Chan Bay",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USBLC",
        portName: "Black Creek",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBCES",
        portName: "Chesterfield",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "DEHSM",
        portName: "Heusenstamm",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBPTL",
        portName: "Portland",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBMIL",
        portName: "Milton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "PACCT",
        portName: "Colon Container Terminal",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "DEOBE",
        portName: "Oberhausen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "AUADL",
        portName: "Adelaide",
        state: "South Australia",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "AUBME",
        portName: "Broome",
        state: "Western Australia",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USHCG",
        portName: "Mechanicsburg",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USA2N",
        portName: "Atlanta",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRCL",
        portName: "Rochelle",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFNX",
        portName: "Forney",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDDJB",
        portName: "Jambi; Sumatra",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "PLGDN",
        portName: "Gdansk",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "GBNHP",
        portName: "Northampton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNLYI",
        portName: "Linyi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USVSN",
        portName: "Winston",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEHAL",
        portName: "Halle",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "FRPSO",
        portName: "Precy-sur-Oise",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "IDJUT",
        portName: "Jakarta Utara",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "CNJYS",
        portName: "Jiangyan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNJGY",
        portName: "Jiangyin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USAFJ",
        portName: "Beloit",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBLAX",
        portName: "Laxo",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "KRUSN",
        portName: "Ulsan",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "MATNG",
        portName: "Tangier",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "IEBEF",
        portName: "Belfast",
        state: null,
        countryCode: "IE",
        countryName: "Ireland",
    },
    {
        portCode: "MXGDL",
        portName: "Guadalajara",
        state: "Jalisco",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "CLLAL",
        portName: "Los Alamos",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "USPAS",
        portName: "Pasadena",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDSRG",
        portName: "Semarang",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USEVT",
        portName: "Everett",
        state: "Massachusetts",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTVY",
        portName: "Team Valley/Gateshead",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBCYM",
        portName: "Clyst St Mary",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USBDL",
        portName: "Windsor Locks-Hartford Apt",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NPBDP",
        portName: "Bhadrapur",
        state: null,
        countryCode: "NP",
        countryName: "Nepal",
    },
    {
        portCode: "GBNCS",
        portName: "Newcastle",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "INCOK",
        portName: "Cochin",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USYYH",
        portName: "Yorkshire",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNPHU",
        portName: "Pinghu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNJAX",
        portName: "Jiaxing Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITPDA",
        portName: "Padova",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "INJDH",
        portName: "Jodhpur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USMKC",
        portName: "Kansas City",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPND",
        portName: "Pearland",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNYSN",
        portName: "Yangshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMES",
        portName: "Minneapolis",
        state: "Minnesota",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNXIS",
        portName: "Xiaoshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USAAM",
        portName: "Salem",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PKLYP",
        portName: "Faisalabad",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "CNYIU",
        portName: "Yiwu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBLBA",
        portName: "Leeds",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "SEGVX",
        portName: "Gavle",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "USJID",
        portName: "City of Industry",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITNLG",
        portName: "Novi Ligure",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USFUL",
        portName: "Fullerton",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNNHS",
        portName: "Sanshan pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "KPFNJ",
        portName: "Pyongyang",
        state: null,
        countryCode: "KP",
        countryName: "North Korea",
    },
    {
        portCode: "GBHIN",
        portName: "Honiton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USEWI",
        portName: "Elwood",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MXCMP",
        portName: "Cumpas",
        state: "Sonora",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "USSRX",
        portName: "Sturtevant",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USRNH",
        portName: "New Richmond",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBMID",
        portName: "Middlesbrough",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "INDRI",
        portName: "Dadri",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "DJJIB",
        portName: "Djibouti",
        state: null,
        countryCode: "DJ",
        countryName: "Djibouti",
    },
    {
        portCode: "EGPSD",
        portName: "Port Said",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "CNJMU",
        portName: "Jiamusi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "VNBDG",
        portName: "Binh Duong Terminal",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "INPVL",
        portName: "Panvel",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "DESPE",
        portName: "Speyer",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USSHV",
        portName: "Shreveport",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USKA3",
        portName: "Kansas",
        state: "Oklahoma",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJRW",
        portName: "Portersville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBQT",
        portName: "Bloomington",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDJKT",
        portName: "Jakarta; Java",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USZJX",
        portName: "South Hampton",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOFR",
        portName: "Oak Forest",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "US2SM",
        portName: "San Manuel",
        state: "Arizona",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSMC",
        portName: "San Marcos",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHRY",
        portName: "Harvey",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USVAB",
        portName: "Virginia Beach",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SARUH",
        portName: "Riyadh",
        state: null,
        countryCode: "SA",
        countryName: "Saudi Arabia",
    },
    {
        portCode: "PLPOL",
        portName: "Polanica-Zdroj",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "INHAR",
        portName: "Haryana",
        state: "Haryana",
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "FRZZY",
        portName: "Douzy",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "ITCVG",
        portName: "Caravaggio",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USWNF",
        portName: "Wisconsin Dells",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAVGN",
        portName: "Vaughan",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USLBR",
        portName: "Lewisberry",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEDUI",
        portName: "Duisburg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USTTI",
        portName: "Stateline",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INAGR",
        portName: "Agra",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "DEHH7",
        portName: "Hauneck",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USPUY",
        portName: "Puyallup",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CASHA",
        portName: "Shawinigan",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USCTC",
        portName: "Charleston",
        state: "Tennessee",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INGGN",
        portName: "Gurgaon",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GBTRK",
        portName: "Thurrock",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBWOV",
        portName: "Wolverhampton",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBDCS",
        portName: "Doncaster",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "INPAV",
        portName: "Pipavav (Victor) Port",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "JMKIN",
        portName: "Kingston",
        state: null,
        countryCode: "JM",
        countryName: "Jamaica",
    },
    {
        portCode: "USKG8",
        portName: "Kingston",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITTRS",
        portName: "Trieste",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USJEP",
        portName: "Jessup",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USNWJ",
        portName: "New Johnsonville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRFOS",
        portName: "Fos-sur-Mer",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "AUABM",
        portName: "Bamaga",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "FJLKB",
        portName: "Lakeba",
        state: null,
        countryCode: "FJ",
        countryName: "Fiji",
    },
    {
        portCode: "USPUP",
        portName: "Dupont",
        state: "Washington",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTOA",
        portName: "Torrance",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GHTEM",
        portName: "Tema",
        state: null,
        countryCode: "GH",
        countryName: "Ghana",
    },
    {
        portCode: "SAJED",
        portName: "Jeddah",
        state: null,
        countryCode: "SA",
        countryName: "Saudi Arabia",
    },
    {
        portCode: "CNYCG",
        portName: "Yancheng",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBNUR",
        portName: "Nursling",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USWTN",
        portName: "Wilmington",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DE222",
        portName: "Brandscheid/Westerwald",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USEV5",
        portName: "Eastvale",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INSON",
        portName: "Sonepat",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GTPBR",
        portName: "Puerto Barrios",
        state: null,
        countryCode: "GT",
        countryName: "Guatemala",
    },
    {
        portCode: "USNWI",
        portName: "New Windsor",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USNLW",
        portName: "North Little Rock",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBBAS",
        portName: "Basildon",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USOXN",
        portName: "Oxnard",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTEE",
        portName: "Teesport",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBRTH",
        portName: "Rotherham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USPPY",
        portName: "Parsippany",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFCL",
        portName: "Florence",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFLR",
        portName: "Florence",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEBR",
        portName: "East Brunswick",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZES",
        portName: "Hazle Township",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DE223",
        portName: "Brandshagen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USBM9",
        portName: "Birmingham Road Estates",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAMIL",
        portName: "Milton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USLGQ",
        portName: "Largo",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "HRRJK",
        portName: "Rijeka",
        state: null,
        countryCode: "HR",
        countryName: "Croatia",
    },
    {
        portCode: "USPER",
        portName: "Perris",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPDQ",
        portName: "Doral",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLSZZ",
        portName: "Szczecin",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USERI",
        portName: "Erie",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBXOL",
        portName: "Lancaster",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBLTT",
        portName: "Lutterworth",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USMSO",
        portName: "Missoula",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJAN",
        portName: "Jackson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEBOY",
        portName: "Bad Oeynhausen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CANWC",
        portName: "Norwich (Ontario)",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "INJNP",
        portName: "Port Jawaharlal Nehru",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GBFEM",
        portName: "Feltham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBFLL",
        portName: "Felling",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USSPK",
        portName: "Sparks",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAMHO",
        portName: "Mount Hope",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "EEPUS",
        portName: "Pusi",
        state: null,
        countryCode: "EE",
        countryName: "Estonia",
    },
    {
        portCode: "USNVM",
        portName: "McCarran",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBPTE",
        portName: "Peterlee",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USIEN",
        portName: "Lancashire",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBEPP",
        portName: "Epping",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USTXC",
        portName: "McAllen",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MXLZC",
        portName: "Lazaro Cardenas",
        state: "Michoacan",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "ITTVE",
        portName: "Trivero",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CAAJX",
        portName: "Ajax",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USCQP",
        portName: "Connellsville",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTRC",
        portName: "Tracy",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEFW",
        portName: "Jefferson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SEGOT",
        portName: "Gothenburg",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "USCSN",
        portName: "Carson City",
        state: "Nevada",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USXRT",
        portName: "Rock Tavern",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIDO",
        portName: "Imperial",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USIMP",
        portName: "Imperial",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAWN",
        portName: "Allentown",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBMHL",
        portName: "Mill Hill",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "DEKAS",
        portName: "Kassel",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "ESLPA",
        portName: "Las Palmas de Gran Canaria",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "GBXMO",
        portName: "Moore Cheshire",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ITCFS",
        portName: "Cafasse",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USMAP",
        portName: "Maple Heights",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNZIB",
        portName: "Zibo",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "SGSCT",
        portName: "Singapore Container Terminal",
        state: null,
        countryCode: "SG",
        countryName: "Singapore",
    },
    {
        portCode: "USKEJ",
        portName: "Lakeland",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CARBC",
        portName: "Richmond",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USNFQ",
        portName: "New Florence",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJYV",
        portName: "Jurupa Valley",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BELUM",
        portName: "Lummen",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "ESODB",
        portName: "Cordoba",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "GBGGU",
        portName: "Grangemounth",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ITTTA",
        portName: "Tortona",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "MTMAR",
        portName: "Marsaxlokk",
        state: null,
        countryCode: "MT",
        countryName: "Malta",
    },
    {
        portCode: "CNXUZ",
        portName: "Xuzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "INPGR",
        portName: "Palghar",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "INBWN",
        portName: "Bhiwandi",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USUYR",
        portName: "Santa Fe Springs",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJBO",
        portName: "Jonesboro",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MYWSP",
        portName: "Westport/Port Klang",
        state: null,
        countryCode: "MY",
        countryName: "Malaysia",
    },
    {
        portCode: "DEBWE",
        portName: "Braunschweig",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "AUDND",
        portName: "Dandenong",
        state: "Victoria",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "PLMAA",
        portName: "Malaszewicze",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USFWA",
        portName: "Fort Wayne",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLOP",
        portName: "Lockport",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAYPA",
        portName: "Prince Albert",
        state: "Saskatchewan",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBKLN",
        portName: "King's Lynn",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "IENVN",
        portName: "Navan",
        state: null,
        countryCode: "IE",
        countryName: "Ireland",
    },
    {
        portCode: "DEZZZ",
        portName: "Etting (Weilheim-Schongau)",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZZW",
        portName: "Zierzow",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZZN",
        portName: "Zeitlarn",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZZL",
        portName: "Zellertal",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZZH",
        portName: "Zuzenhausen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZXN",
        portName: "Kindelbruck",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZXK",
        portName: "Zehdenick",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZXB",
        portName: "Zierenberg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZX6",
        portName: "Wachtendonk",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZWZ",
        portName: "Zwonitz",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZWY",
        portName: "Wittenforden",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEZWT",
        portName: "Wittenbergen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USXHE",
        portName: "Kearny",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USVIS",
        portName: "Visalia",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPIT",
        portName: "Pittsburgh",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAZFW",
        portName: "Fairview",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "TRSAW",
        portName: "Sabiha Gokcen Apt/Istanbul",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "DEGWS",
        portName: "Grosswallstadt",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USCRC",
        portName: "Commerce/Los Angeles",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNSNZ",
        portName: "Sanzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USGRP",
        portName: "Greencastle",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHDO",
        portName: "Henderson",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USROI",
        portName: "Romeoville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUECR",
        portName: "Eastern Creek",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "DEPEI",
        portName: "Peine",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBDRH",
        portName: "Durham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USWCT",
        portName: "West Chester",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBGRG",
        portName: "Grangemouth",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "COBAQ",
        portName: "Barranquilla",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "USACE",
        portName: "Carol Stream",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "HUEBS",
        portName: "Ebes",
        state: null,
        countryCode: "HU",
        countryName: "Hungary",
    },
    {
        portCode: "USEEU",
        portName: "Edgerton",
        state: "Kansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEEF",
        portName: "Greenfield",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CZDMV",
        portName: "Detmarovice",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "GBCEM",
        portName: "Clayton-le-Moors",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNFUN",
        portName: "Fuyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USGDP",
        portName: "Grand Prairie",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CALAV",
        portName: "Laval",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "NPBRG",
        portName: "Birgunj",
        state: null,
        countryCode: "NP",
        countryName: "Nepal",
    },
    {
        portCode: "-----",
        portName: "Unassigned",
        state: null,
        countryCode: "--",
        countryName: "Unassigned",
    },
    {
        portCode: "USQHO",
        portName: "Oak Brook",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USAUL",
        portName: "Austell",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNHUI",
        portName: "Huizhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CLSAI",
        portName: "San Antonio",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "GBTYM",
        portName: "Tynemouth",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNHGK",
        portName: "Hongkou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "MXATM",
        portName: "Altamira",
        state: "Tamaulipas",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "CNJTN",
        portName: "Jintan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSQU",
        portName: "Shiqiao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLIS",
        portName: "Lishui",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "KEMBA",
        portName: "Mombasa",
        state: null,
        countryCode: "KE",
        countryName: "Kenya",
    },
    {
        portCode: "USIRD",
        portName: "Irwindale",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USANA",
        portName: "Anaheim",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNZSN",
        portName: "Zhongshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "EGDAM",
        portName: "Dumyat (Damietta)",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "USLBF",
        portName: "North Platte",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBDBS",
        portName: "Derbyshire",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNTXZ",
        portName: "Tongxiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNXIN",
        portName: "Xinhui",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "TRISL",
        portName: "Ataturk Airport",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "IDTPP",
        portName: "Tanjung Priok",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "USASC",
        portName: "Arkansas City",
        state: "Arkansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRMAD",
        portName: "Mardas",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "USNEK",
        portName: "Newark",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBAY",
        portName: "Bayonne",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "US6ST",
        portName: "Somerset",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USJWC",
        portName: "New Castle",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCC5",
        portName: "City of Commerce",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ESBIO",
        portName: "Bilbao",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USINT",
        portName: "Winston Salem",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEAT3",
        portName: "Altrip",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DEVIE",
        portName: "Viersen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "ITMNZ",
        portName: "Manzano",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DEWLT",
        portName: "Werlte",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "BGMAD",
        portName: "Madan",
        state: null,
        countryCode: "BG",
        countryName: "Bulgaria",
    },
    {
        portCode: "GBCOT",
        portName: "Coatbridge",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "PTLEI",
        portName: "Leixoes",
        state: null,
        countryCode: "PT",
        countryName: "Portugal",
    },
    {
        portCode: "USOGG",
        portName: "Kahului",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPSMZ",
        portName: "Shimizu",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "MDKIV",
        portName: "Chisinau (ex Kishinev)",
        state: null,
        countryCode: "MD",
        countryName: "Moldova",
    },
    {
        portCode: "FRZZZ",
        portName: "Saint-Pierre-des-Landes",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CARHI",
        portName: "Richmond Hill",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USFAH",
        portName: "Fairless Hills",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBNEP",
        portName: "Newport",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "TRDNZ",
        portName: "Denizli",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "MXZLO",
        portName: "Manzanillo",
        state: "Colima",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "CANWE",
        portName: "New Westminster",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBPAS",
        portName: "Paisley",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USAVE",
        portName: "Avenel",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FR222",
        portName: "Coulmier-le-Sec",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "NOSVG",
        portName: "Stavanger",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "USCMT",
        portName: "Commerce City",
        state: "Colorado",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFWT",
        portName: "Fort Worth",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBHRL",
        portName: "Harlow",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "AEDWC",
        portName: "Dubai World Central Airport",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "DELUE",
        portName: "Lunen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USJO4",
        portName: "Saint Johns",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSTP",
        portName: "Saint Paul",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USNVK",
        portName: "Newbury Park",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRTEK",
        portName: "Tekirdag",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "USBUN",
        portName: "Buena Park",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGBD",
        portName: "Great Bend",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRCUO",
        portName: "Cubatao",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "USPGP",
        portName: "Penns Grove",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLAV",
        portName: "Lawrenceville",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CALAC",
        portName: "Lachine",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USMC5",
        portName: "Missouri City",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPCHI",
        portName: "China",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "TRVAN",
        portName: "Van",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "CASJB",
        portName: "Saint-John",
        state: "New Brunswick",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "AUVDS",
        portName: "Dandenong South",
        state: "Victoria",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USWKR",
        portName: "Wake Forest",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAWDB",
        portName: "Woodbridge",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USSAC",
        portName: "Sacramento",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRAMB",
        portName: "Ambarli",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "USNNY",
        portName: "Newark",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMLB",
        portName: "Melbourne",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PTPXO",
        portName: "Porto Santo Island",
        state: null,
        countryCode: "PT",
        countryName: "Portugal",
    },
    {
        portCode: "ITMZO",
        portName: "Melzo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "ITSGE",
        portName: "Segrate",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "FRLA2",
        portName: "Les Arsures",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "DEMNS",
        portName: "Mohnesee",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USCLD",
        portName: "Carlsbad",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CZPRG",
        portName: "Praha",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "GBWFD",
        portName: "Wakefield",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USEGG",
        portName: "Egg Harbor City",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USXHV",
        portName: "Largo",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRSNO",
        portName: "Senlis",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USHXC",
        portName: "Haslett",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITPLO",
        portName: "Pioltello",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "ITBRC",
        portName: "Brescia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "EGPSW",
        portName: "Port Said West",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "USJCT",
        portName: "Junction",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSHX",
        portName: "Shageluk",
        state: "Alaska",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BEANT",
        portName: "Antwerp Churchill Terminal",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "USNGZ",
        portName: "Alameda",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CAVAC",
        portName: "North Vancouver",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "EGTRC",
        portName: "10th of Ramadan City",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "DESCE",
        portName: "Schwerte",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNWEN",
        portName: "Wenling",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CANPN",
        portName: "Nepean",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "HNPCR",
        portName: "Puerto Cortes",
        state: null,
        countryCode: "HN",
        countryName: "Honduras",
    },
    {
        portCode: "GBOBY",
        portName: "Oldbury",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "BGVAR",
        portName: "Varna",
        state: null,
        countryCode: "BG",
        countryName: "Bulgaria",
    },
    {
        portCode: "ITVDL",
        portName: "Vado Ligure",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USRIJ",
        portName: "Ringwood",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSOJ",
        portName: "Somerset",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEHEL",
        portName: "Helmstedt",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CAYHC",
        portName: "Hakai Pass",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "PKKCF",
        portName: "Kadanwari",
        state: null,
        countryCode: "PK",
        countryName: "Pakistan",
    },
    {
        portCode: "KRINC",
        portName: "Incheon",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "USOLQ",
        portName: "Tolleson",
        state: "Arizona",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INENR",
        portName: "Ennore",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "TRMPT",
        portName: "Marport",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "DEHAJ",
        portName: "Hannover",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBSFK",
        portName: "Scarfskerry",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CAWTL",
        portName: "Waterloo",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USHLS",
        portName: "Hillside",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEGOE",
        portName: "Gottingen",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNDNY",
        portName: "Danyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNDEQ",
        portName: "Deqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNDEY",
        portName: "Deyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNDYA",
        portName: "Dongyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNFYG",
        portName: "Fuyong",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNKWL",
        portName: "Guilin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNGUI",
        portName: "Guilin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ESDAC",
        portName: "Mundaca",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USBIL",
        portName: "Billings",
        state: "Montana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ROOTP",
        portName: "Otopeni Apt/Bucuresti",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "ROBRV",
        portName: "Brasov",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "USPOC",
        portName: "La Verne",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITSMA",
        portName: "Santa Marinella",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "ILHAD",
        portName: "Hadera",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USHQN",
        portName: "Houston",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USVNY",
        portName: "Van Nuys",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "JPHIU",
        portName: "Hiratsuka",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "CAEGV",
        portName: "Eganville",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "DEWTP",
        portName: "Waltrop",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "TTTAB",
        portName: "Tobago",
        state: null,
        countryCode: "TT",
        countryName: "Trinidad and Tobago",
    },
    {
        portCode: "KYGCM",
        portName: "Grand Cayman",
        state: null,
        countryCode: "KY",
        countryName: "Cayman Islands",
    },
    {
        portCode: "PLBYW",
        portName: "Bielany Wroclawskie",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "CZRCY",
        portName: "Ricany",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "GBGSY",
        portName: "Grimsby",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNYSA",
        portName: "Yangshan Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ITLGB",
        portName: "Lesignano de' Bagni",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "SADMM",
        portName: "Ad Dammam",
        state: null,
        countryCode: "SA",
        countryName: "Saudi Arabia",
    },
    {
        portCode: "CMKBI",
        portName: "Kribi",
        state: null,
        countryCode: "CM",
        countryName: "Cameroon",
    },
    {
        portCode: "VECCS",
        portName: "Caracas",
        state: null,
        countryCode: "VE",
        countryName: "Venezuela",
    },
    {
        portCode: "GUGUM",
        portName: "Guam",
        state: null,
        countryCode: "GU",
        countryName: "Guam",
    },
    {
        portCode: "USLEX",
        portName: "Lexington",
        state: "Kentucky",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "HNSMH",
        portName: "San Manuel",
        state: null,
        countryCode: "HN",
        countryName: "Honduras",
    },
    {
        portCode: "INPNY",
        portName: "Pondicherry",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "VNTCG",
        portName: "Tan Cang",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "ITBAO",
        portName: "Basiano",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "SESZX",
        portName: "Tofta",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "JPSGH",
        portName: "Sagamihara",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "GBPHD",
        portName: "Peterhead",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ITCLT",
        portName: "Collalto",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CNHRB",
        portName: "Harbin",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "FRLYS",
        portName: "Lyon",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "ITPSB",
        portName: "Peschiera Borromeo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "FRMIM",
        portName: "Mitry-Mory",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "RUNVS",
        portName: "Novorossiysk",
        state: null,
        countryCode: "RU",
        countryName: "Russia",
    },
    {
        portCode: "GBBLL",
        portName: "Bellshill",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "COBUN",
        portName: "Buenaventura",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "USNAP",
        portName: "North East",
        state: "Maryland",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "IDBTH",
        portName: "Batam (ex Batu Besar)",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "IDBUR",
        portName: "Batu Ampal",
        state: null,
        countryCode: "ID",
        countryName: "Indonesia",
    },
    {
        portCode: "MXPVR",
        portName: "Puerto Vallarta",
        state: "Jalisco",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "ITRDZ",
        portName: "Romanengo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USMD5",
        portName: "Meredith",
        state: "New Hampshire",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLKTW",
        portName: "Katowice",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "ITENG",
        portName: "Pianengo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "CNTAG",
        portName: "Taicang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "JPSKU",
        portName: "Shiraku",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USAWS",
        portName: "Newcastle",
        state: "Maine",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBRSD",
        portName: "Rossington",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USLRD",
        portName: "Laredo",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ESLDO",
        portName: "Laredo",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CAYCS",
        portName: "Chesterfield Inlet",
        state: "Nunavut",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNCAW",
        portName: "Chaiwan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "VNHPO",
        portName: "HAI PONG",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "DERHB",
        portName: "Rheinberg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "ITAOI",
        portName: "Ancona",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DEHEM",
        portName: "Heidenheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "INVTZ",
        portName: "Visakhapatnam",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "MXESE",
        portName: "Ensenada",
        state: "Baja California",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "AUWKF",
        portName: "Warwick Farm",
        state: "New South Wales",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "DEWAR",
        portName: "Warnemunde",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MXTIJ",
        portName: "Tijuana",
        state: "Baja California Sur",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "IRRUD",
        portName: "Shahrood",
        state: null,
        countryCode: "IR",
        countryName: "Iran",
    },
    {
        portCode: "USEZA",
        portName: "Elizabeth",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AUFRE",
        portName: "Fremantle",
        state: "Western Australia",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "GBXRC",
        portName: "Runcorn",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "LTVIL",
        portName: "Vilnius",
        state: null,
        countryCode: "LT",
        countryName: "Lithuania",
    },
    {
        portCode: "USRGD",
        portName: "Ringgold",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBTNW",
        portName: "Stanway",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "EGCAI",
        portName: "Cairo",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "DEWRE",
        portName: "Werne",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CRCAL",
        portName: "Caldera",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "DEGMF",
        portName: "Gremmendorf",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GEPTI",
        portName: "Poti",
        state: null,
        countryCode: "GE",
        countryName: "Georgia",
    },
    {
        portCode: "ITROU",
        portName: "Roure",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DENAT",
        portName: "Nattheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MXSMA",
        portName: "San Mateo Atenco",
        state: "Mexico",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "ESPXA",
        portName: "Paterna",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "PABLB",
        portName: "Balboa",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "GBCLL",
        portName: "Coleshill",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBBID",
        portName: "Bideford",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USPDS",
        portName: "Powder Springs",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITZJA",
        portName: "Fornovo San Giovanni",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "GETBS",
        portName: "Tbilisi",
        state: null,
        countryCode: "GE",
        countryName: "Georgia",
    },
    {
        portCode: "USMGJ",
        portName: "Montgomery",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "RWKGL",
        portName: "Kigali",
        state: null,
        countryCode: "RW",
        countryName: "Rwanda",
    },
    {
        portCode: "USVCV",
        portName: "Victorville",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USUFG",
        portName: "Chesapeake",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTWQ",
        portName: "Winton",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITTGL",
        portName: "Travagliato",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "GBGRK",
        portName: "Greenock",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CADAC",
        portName: "Dacre",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "HNSAP",
        portName: "San Pedro Sula",
        state: null,
        countryCode: "HN",
        countryName: "Honduras",
    },
    {
        portCode: "DETVT",
        portName: "Tonisvorst",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MXVER",
        portName: "Veracruz",
        state: "Veracruz",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "BWBBK",
        portName: "Kasane",
        state: null,
        countryCode: "BW",
        countryName: "Botswana",
    },
    {
        portCode: "BWGBE",
        portName: "Gaborone",
        state: null,
        countryCode: "BW",
        countryName: "Botswana",
    },
    {
        portCode: "INPNQ",
        portName: "Pune",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "SVSAL",
        portName: "San Salvador",
        state: null,
        countryCode: "SV",
        countryName: "El Salvador",
    },
    {
        portCode: "ZADAC",
        portName: "De Aar",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "CNZQG",
        portName: "Zhaoqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNZJG",
        portName: "Zhangjiagang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNZOH",
        portName: "Zaozhuang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNYUE",
        portName: "Yueqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNYJI",
        portName: "Yangjiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNXZH",
        portName: "Xuzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSIA",
        portName: "Xi'an",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNWUX",
        portName: "Wuxi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNWEH",
        portName: "Weihai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNWEI",
        portName: "Weihai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTIA",
        portName: "Tiantai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTZO",
        portName: "Taizhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTAX",
        portName: "Taixing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNTIS",
        portName: "Taishan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSZH",
        portName: "Suzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSJZ",
        portName: "Shijiazhuang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSGU",
        portName: "Shangyu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSJQ",
        portName: "Sanshui",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNSAM",
        portName: "Sanming / Shanming Shi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNRZH",
        portName: "Rizhao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNQUZ",
        portName: "Quzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNQGY",
        portName: "Qingyuan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNPYG",
        portName: "Puyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNPUT",
        portName: "Putian",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNPDU",
        portName: "Pingdu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNNTU",
        portName: "Nantou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLGG",
        portName: "Longgang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLNH",
        portName: "Linhai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLLI",
        portName: "Liling",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLIG",
        portName: "Liaocheng",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNLFG",
        portName: "Langfang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNJJI",
        portName: "Jinjiang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNJYG",
        portName: "Jieyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNJSA",
        portName: "Jiashan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHUZ",
        portName: "Huazhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHSI",
        portName: "Huangshi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHEY",
        portName: "Heyuan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHIN",
        portName: "Haining",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "ESZZZ",
        portName: "Aoiz",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CNCHZ",
        portName: "Chuzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCON",
        portName: "Chaoan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCNA",
        portName: "Changsha",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCZU",
        portName: "Cangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNBAZ",
        portName: "Bazhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "BHBAH",
        portName: "Bahrain",
        state: null,
        countryCode: "BH",
        countryName: "Bahrain",
    },
    {
        portCode: "ALDRZ",
        portName: "Durres",
        state: null,
        countryCode: "AL",
        countryName: "Albania",
    },
    {
        portCode: "ALTIA",
        portName: "Tirana",
        state: null,
        countryCode: "AL",
        countryName: "Albania",
    },
    {
        portCode: "CNYIC",
        portName: "Yichang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNCQI",
        portName: "Chongqing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHZH",
        portName: "Huzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "NZLGB",
        portName: "Longburn",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "GBBEQ",
        portName: "Bury St Edmunds",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "DEZWO",
        portName: "Zwochau",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CAFFS",
        portName: "Fort Frances",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CLIQQ",
        portName: "Iquique",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "CLPUQ",
        portName: "Punta Arenas",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "CLVAP",
        portName: "Valparaiso",
        state: null,
        countryCode: "CL",
        countryName: "Chile",
    },
    {
        portCode: "CAPTC",
        portName: "Port Coquitlam",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYQB",
        portName: "Quebec",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAXFL",
        portName: "Shawinigan",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYSJ",
        portName: "Saint John",
        state: "New Brunswick",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAWNP",
        portName: "Winnipeg",
        state: "Manitoba",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAABB",
        portName: "Abbotsford",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CASJF",
        portName: "Saint-John's",
        state: "Newfoundland",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAPAB",
        portName: "Port Alberni",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAVIC",
        portName: "Victoria",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CATWS",
        portName: "Tsawwassen",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAJPJ",
        portName: "Saint-Jean-Port-Joli",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAOTT",
        portName: "Ottawa",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CANYK",
        portName: "North York",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CALDC",
        portName: "Leduc",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAKTC",
        portName: "Kitchener",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYKF",
        portName: "Kitchener",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAXJL",
        portName: "Joliette",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAFKO",
        portName: "Frankford",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CACNC",
        portName: "Concord",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CACWK",
        portName: "Chilliwack",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAGAL",
        portName: "Cambridge (ex Galt)",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAYCB",
        portName: "Cambridge Bay",
        state: "Nunavut",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CACAL",
        portName: "Calgary",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CABUB",
        portName: "Burnaby",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CABRL",
        portName: "Burlington",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CABRO",
        portName: "Brossard",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CABRP",
        portName: "Brampton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CAHAM",
        portName: "Hamilton",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNSTG",
        portName: "Shantou Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "KHKMT",
        portName: "Kampot",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "KHKKZ",
        portName: "Koh Kong",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "BRQNT",
        portName: "Niteroi",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRGIG",
        portName: "Rio De Janeiro Int'l Apt",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRRIO",
        portName: "Rio de Janeiro",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRPNG",
        portName: "Paranagua",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRSSA",
        portName: "Salvador",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BRSTM",
        portName: "Santarem",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "BDPAY",
        portName: "Payra Port",
        state: null,
        countryCode: "BD",
        countryName: "Bangladesh",
    },
    {
        portCode: "BDMGL",
        portName: "Mongla",
        state: null,
        countryCode: "BD",
        countryName: "Bangladesh",
    },
    {
        portCode: "BSTBI",
        portName: "The Bight - Cat Island",
        state: null,
        countryCode: "BS",
        countryName: "Bahamas",
    },
    {
        portCode: "AZBAK",
        portName: "Baku",
        state: null,
        countryCode: "AZ",
        countryName: "Azerbaijan",
    },
    {
        portCode: "AUBRA",
        portName: "Brisbane Apt",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "AGSJO",
        portName: "St John's",
        state: null,
        countryCode: "AG",
        countryName: "Antigua and Barbuda",
    },
    {
        portCode: "AFKBL",
        portName: "Kabul",
        state: null,
        countryCode: "AF",
        countryName: "Afghanistan",
    },
    {
        portCode: "ARBUE",
        portName: "Buenos Aires",
        state: null,
        countryCode: "AR",
        countryName: "Argentina",
    },
    {
        portCode: "USHRO",
        portName: "Harrison",
        state: "Arkansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USOX3",
        portName: "Oxford",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DELWG",
        portName: "Ludwigsburg",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GBOXF",
        portName: "Oxford",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "ITSSM",
        portName: "Sasso Marconi",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USMAZ",
        portName: "Madison",
        state: "Alabama",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USING",
        portName: "Inglewood",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KRKPO",
        portName: "Pohang",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "CVMTI",
        portName: "Mosteiros",
        state: null,
        countryCode: "CV",
        countryName: "Cape Verde",
    },
    {
        portCode: "NEMFQ",
        portName: "Maradi",
        state: null,
        countryCode: "NE",
        countryName: "Niger",
    },
    {
        portCode: "DEHGL",
        portName: "Helgoland",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "BSCAT",
        portName: "Cat Island",
        state: null,
        countryCode: "BS",
        countryName: "Bahamas",
    },
    {
        portCode: "ESIBZ",
        portName: "Ibiza",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "SEMMX",
        portName: "Malmo Airport",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "PLWWC",
        portName: "Wojkowice",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "GBBRM",
        portName: "Brantham",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "DEBIF",
        portName: "Birkenfeld",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "AEKHL",
        portName: "Mina Khalifa (Abu Dhabi)",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "LBBEY",
        portName: "Beirut",
        state: null,
        countryCode: "LB",
        countryName: "Lebanon",
    },
    {
        portCode: "PLGDK",
        portName: "Gadki",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "NOMAY",
        portName: "Maloy",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "CNPNU",
        portName: "Pinghu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USYIT",
        portName: "Plantation",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRITJ",
        portName: "Itajai",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "DENUL",
        portName: "Neu Ulm",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "DESAC",
        portName: "Sachsen bei Ansbach",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "UZTAS",
        portName: "Tashkent",
        state: null,
        countryCode: "UZ",
        countryName: "Uzbekistan",
    },
    {
        portCode: "PHLAO",
        portName: "Laoag; Luzon",
        state: null,
        countryCode: "PH",
        countryName: "Philippines",
    },
    {
        portCode: "USODR",
        portName: "Old Bridge",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBUO",
        portName: "Beaumont",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "VNCLN",
        portName: "Cai Lan",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "FRTLS",
        portName: "Toulouse",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "OMMCT",
        portName: "Muscat",
        state: null,
        countryCode: "OM",
        countryName: "Oman",
    },
    {
        portCode: "BRSDO",
        portName: "Santos Dumont",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "GBSLH",
        portName: "Stanford-le-Hope",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USALH",
        portName: "Alhambra",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPQU",
        portName: "Pico Rivera",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USWLU",
        portName: "Walnut",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLBZG",
        portName: "Bydgoszcz",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "ITSAL",
        portName: "Salerno",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "DKAZS",
        portName: "Aars",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "NZTIU",
        portName: "Timaru",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "CNHAZ",
        portName: "Hangzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "UARNI",
        portName: "Reni",
        state: null,
        countryCode: "UA",
        countryName: "Ukraine",
    },
    {
        portCode: "JPHKJ",
        portName: "Hamasaka",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "GBREN",
        portName: "Renfrew",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "NOAES",
        portName: "Alesund",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "SCSEZ",
        portName: "Mahe Island Apt",
        state: null,
        countryCode: "SC",
        countryName: "Seychelles",
    },
    {
        portCode: "DKAAR",
        portName: "Arhus",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "DKBLL",
        portName: "Billund",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "INIXY",
        portName: "Kandla",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "PLGRA",
        portName: "Gora",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "DEULM",
        portName: "Ulm",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USUKK",
        portName: "University Park",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USUPK",
        portName: "University Park",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSXT",
        portName: "Santa Teresa",
        state: "New Mexico",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CHBRN",
        portName: "Bern",
        state: null,
        countryCode: "CH",
        countryName: "Switzerland",
    },
    {
        portCode: "BRRBR",
        portName: "Rio Branco",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "AUBCI",
        portName: "Barcaldine",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "ROBUH",
        portName: "Bucharest",
        state: null,
        countryCode: "RO",
        countryName: "Romania",
    },
    {
        portCode: "DEWNK",
        portName: "Windeck",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "PLIEG",
        portName: "Zielona Gora",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "ESPRR",
        portName: "Porrino",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "USCPF",
        portName: "Chippewa Falls",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "AESHJ",
        portName: "Sharjah",
        state: null,
        countryCode: "AE",
        countryName: "United Arab Emirates",
    },
    {
        portCode: "USHJ2",
        portName: "Hopewell Junction",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNXAM",
        portName: "Xiamen",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "DEMHG",
        portName: "Mannheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNXAO",
        portName: "Xiaolan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USLIM",
        portName: "Milan",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBIPS",
        portName: "Ipswich",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBABD",
        portName: "Aberdeen",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "BRVIX",
        portName: "Vitoria",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "GBDXY",
        portName: "Derby",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CALOD",
        portName: "London",
        state: "Ontario",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CNCGS",
        portName: "Changshu Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "GBBEL",
        portName: "Belfast",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CNNYG",
        portName: "Nanyang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USIRV",
        portName: "Irving",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITPCZ",
        portName: "Piacenza",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "JPFUK",
        portName: "Fukuoka",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "MZMPM",
        portName: "Maputo",
        state: null,
        countryCode: "MZ",
        countryName: "Mozambique",
    },
    {
        portCode: "SESOL",
        portName: "Solvesborg",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "USPNJ",
        portName: "Port Newark",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTPL",
        portName: "Temple",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNSGH",
        portName: "Shanghai",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "DEZHH",
        portName: "Hinternah",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "PLNOW",
        portName: "Nowy Port/Gdansk",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USUQF",
        portName: "La Porte",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "EGPSE",
        portName: "Port Said East",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "ATSZG",
        portName: "Salzburg",
        state: null,
        countryCode: "AT",
        countryName: "Austria",
    },
    {
        portCode: "SKZSK",
        portName: "Strazske",
        state: null,
        countryCode: "SK",
        countryName: "Slovakia",
    },
    {
        portCode: "PLNDG",
        portName: "Nowy Dwor Gdanski",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "USHSR",
        portName: "Harrisburg",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBZE",
        portName: "Belton",
        state: "Missouri",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USEAJ",
        portName: "Eatontown",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "DEHBM",
        portName: "Herbolzheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "NLHFD",
        portName: "Hoofddorp",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "GHACC",
        portName: "Accra",
        state: null,
        countryCode: "GH",
        countryName: "Ghana",
    },
    {
        portCode: "KMHAH",
        portName: "Hahaya Apt/Moroni",
        state: null,
        countryCode: "KM",
        countryName: "Comoros",
    },
    {
        portCode: "KWSWK",
        portName: "Shuwaikh",
        state: null,
        countryCode: "KW",
        countryName: "Kuwait",
    },
    {
        portCode: "CYLMS",
        portName: "Limassol",
        state: null,
        countryCode: "CY",
        countryName: "Cyprus",
    },
    {
        portCode: "VEPBL",
        portName: "Puerto Cabello",
        state: null,
        countryCode: "VE",
        countryName: "Venezuela",
    },
    {
        portCode: "SVAQJ",
        portName: "Acajutla",
        state: null,
        countryCode: "SV",
        countryName: "El Salvador",
    },
    {
        portCode: "DKODE",
        portName: "Odense",
        state: null,
        countryCode: "DK",
        countryName: "Denmark",
    },
    {
        portCode: "NOBGO",
        portName: "Bergen",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "DE23A",
        portName: "Leinatal",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "GALBV",
        portName: "Libreville",
        state: null,
        countryCode: "GA",
        countryName: "Gabon",
    },
    {
        portCode: "CGPNR",
        portName: "Pointe Noire",
        state: null,
        countryCode: "CG",
        countryName: "Congo (Brazzaville)",
    },
    {
        portCode: "ESTRO",
        portName: "Toro",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "MNUBN",
        portName: "Chinggis Khaan Airport",
        state: null,
        countryCode: "MN",
        countryName: "Mongolia",
    },
    {
        portCode: "ITPMO",
        portName: "Palermo",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "JOAMM",
        portName: "Amman",
        state: null,
        countryCode: "JO",
        countryName: "Jordan",
    },
    {
        portCode: "DOCAU",
        portName: "Caucedo",
        state: null,
        countryCode: "DO",
        countryName: "Dominican Republic",
    },
    {
        portCode: "USGCG",
        portName: "Garden City",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNEZH",
        portName: "Ezhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CNHSH",
        portName: "Huangshan",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "TRAYT",
        portName: "Antalya",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "KENBO",
        portName: "Nairobi",
        state: null,
        countryCode: "KE",
        countryName: "Kenya",
    },
    {
        portCode: "BRVCP",
        portName: "Viracopos Apt / Campinas",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "CAPIM",
        portName: "Pitt Meadows",
        state: "British Columbia",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "MGTNR",
        portName: "Antananarivo",
        state: null,
        countryCode: "MG",
        countryName: "Madagascar",
    },
    {
        portCode: "CNXIP",
        portName: "Xingang",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "OMSOH",
        portName: "Sohar",
        state: null,
        countryCode: "OM",
        countryName: "Oman",
    },
    {
        portCode: "GTPRQ",
        portName: "Puerto Quetzal",
        state: null,
        countryCode: "GT",
        countryName: "Guatemala",
    },
    {
        portCode: "MAPTM",
        portName: "Tanger Med",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "TZDAR",
        portName: "Dar es Salaam",
        state: null,
        countryCode: "TZ",
        countryName: "Tanzania",
    },
    {
        portCode: "EGALY",
        portName: "El Iskandariya (Alexandria)",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "ECGYE",
        portName: "Guayaquil",
        state: null,
        countryCode: "EC",
        countryName: "Ecuador",
    },
    {
        portCode: "TRESB",
        portName: "Ankara",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "USHTQ",
        portName: "Huntley",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GTSTC",
        portName: "Santo Tomas de Castilla",
        state: null,
        countryCode: "GT",
        countryName: "Guatemala",
    },
    {
        portCode: "BRIOA",
        portName: "Itapoa",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "TRKYA",
        portName: "Konya",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "JPIHA",
        portName: "Niihama",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "GNCKY",
        portName: "Conakry",
        state: null,
        countryCode: "GN",
        countryName: "Guinea",
    },
    {
        portCode: "BBBGI",
        portName: "Bridgetown",
        state: null,
        countryCode: "BB",
        countryName: "Barbados",
    },
    {
        portCode: "JPMMB",
        portName: "Memanbetsu",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "TRGEM",
        portName: "Gemlik",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "TRADA",
        portName: "Adana",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "YEMKX",
        portName: "Mukalla",
        state: null,
        countryCode: "YE",
        countryName: "Yemen",
    },
    {
        portCode: "CAMTN",
        portName: "Marystown",
        state: null,
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "FIRAU",
        portName: "Rauma (Raumo)",
        state: null,
        countryCode: "FI",
        countryName: "Finland",
    },
    {
        portCode: "NOFRK",
        portName: "Fredrikstad",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "GBKNO",
        portName: "Knottingley",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "TRSZF",
        portName: "Carsamba Apt/Samsun",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "CNLHW",
        portName: "Lanzhou Zhongchuan Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "MARAK",
        portName: "Marrakech",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "INPPG",
        portName: "Patparganj",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USBOT",
        portName: "Beloit",
        state: "Wisconsin",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USCKV",
        portName: "Clarksville",
        state: "Tennessee",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRSSX",
        portName: "Samsun",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "TRGEB",
        portName: "Gebze",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "ATLNZ",
        portName: "Linz",
        state: null,
        countryCode: "AT",
        countryName: "Austria",
    },
    {
        portCode: "MGPSL",
        portName: "Port Saint Louis",
        state: null,
        countryCode: "MG",
        countryName: "Madagascar",
    },
    {
        portCode: "FRZZO",
        portName: "Grancey-sur-Ource",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "ITAUG",
        portName: "Augusta",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "BRMAO",
        portName: "Manaus",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "INBDQ",
        portName: "Vadodara",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "SCPOV",
        portName: "Port Victoria",
        state: null,
        countryCode: "SC",
        countryName: "Seychelles",
    },
    {
        portCode: "USOQY",
        portName: "Oakley",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "METGD",
        portName: "Podgorica",
        state: null,
        countryCode: "ME",
        countryName: "Montenegro",
    },
    {
        portCode: "CNQZH",
        portName: "Qinzhou",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USMQ4",
        portName: "Maher Terminal",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INKNU",
        portName: "Kanpur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "GRSKG",
        portName: "Thessaloniki",
        state: null,
        countryCode: "GR",
        countryName: "Greece",
    },
    {
        portCode: "CNEHU",
        portName: "Ezhou Huahu Airport",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USSVY",
        portName: "Sun Valley",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "KHKZC",
        portName: "Kampong Chhnang",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "USRAG",
        portName: "Raleigh",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MGTMM",
        portName: "Tamatave (Toamasina)",
        state: null,
        countryCode: "MG",
        countryName: "Madagascar",
    },
    {
        portCode: "INMRM",
        portName: "Marmagao (Marmugao)",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "TRIZT",
        portName: "Izmit",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "BRREC",
        portName: "Recife",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "NLGRZ",
        portName: "Gravenzande",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "WSAPW",
        portName: "Apia",
        state: null,
        countryCode: "WS",
        countryName: "Samoa",
    },
    {
        portCode: "BRSUA",
        portName: "Suape Pt / Ipojuca",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "PACTB",
        portName: "Cristobal",
        state: null,
        countryCode: "PA",
        countryName: "Panama",
    },
    {
        portCode: "MUPLU",
        portName: "Port Louis",
        state: null,
        countryCode: "MU",
        countryName: "Mauritius",
    },
    {
        portCode: "TGLFW",
        portName: "Lome",
        state: null,
        countryCode: "TG",
        countryName: "Togo",
    },
    {
        portCode: "CNGYS",
        portName: "Guangyuan Panlong Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "EEPIR",
        portName: "Pirita",
        state: null,
        countryCode: "EE",
        countryName: "Estonia",
    },
    {
        portCode: "USAIG",
        portName: "Lansing",
        state: "Ohio",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMBU",
        portName: "Middlebury",
        state: "Vermont",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "LCCAS",
        portName: "Castries",
        state: null,
        countryCode: "LC",
        countryName: "Saint Lucia",
    },
    {
        portCode: "LCSLU",
        portName: "Saint Lucia Apt",
        state: null,
        countryCode: "LC",
        countryName: "Saint Lucia",
    },
    {
        portCode: "JOAQB",
        portName: "Aqaba",
        state: null,
        countryCode: "JO",
        countryName: "Jordan",
    },
    {
        portCode: "USMUV",
        portName: "Mountain Top",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MKSKP",
        portName: "Skopje",
        state: null,
        countryCode: "MK",
        countryName: "Macedonia",
    },
    {
        portCode: "USCMR",
        portName: "Camarillo",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MXACN",
        portName: "Ciudad Acuna",
        state: null,
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "CNSHG",
        portName: "Shanghai Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "TREYP",
        portName: "Evyap Port",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "TRDRC",
        portName: "Derince",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "EGEDK",
        portName: "El Dekheila",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "GBMIK",
        portName: "Milton Keynes",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "NLGRA",
        portName: "Gravendeel",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "CMDLA",
        portName: "Douala",
        state: null,
        countryCode: "CM",
        countryName: "Cameroon",
    },
    {
        portCode: "US2BY",
        portName: "Ballston Lake",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITCVV",
        portName: "Civitavecchia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USB2V",
        portName: "Buena Vista",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBSAV",
        portName: "Stratford-upon-Avon",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "GBCNB",
        portName: "Canterbury",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "MXNLU",
        portName: "santa lucia",
        state: "Mexico City",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "NIMGA",
        portName: "Managua",
        state: null,
        countryCode: "NI",
        countryName: "Nicaragua",
    },
    {
        portCode: "COCNR",
        portName: "Contecar",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "GYGEO",
        portName: "Georgetown",
        state: null,
        countryCode: "GY",
        countryName: "Guyana",
    },
    {
        portCode: "USWVC",
        portName: "West Valley City",
        state: "Utah",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLFR",
        portName: "Lake Forest",
        state: "Illinois",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNPKX",
        portName: "Daxing",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "SMSAI",
        portName: "San Marino",
        state: null,
        countryCode: "SM",
        countryName: "San Marino",
    },
    {
        portCode: "ILDIM",
        portName: "Dimona",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USRDP",
        portName: "Randolph",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHPY",
        portName: "Baytown",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPTM",
        portName: "Portsmouth",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ISKEF",
        portName: "Keflavik",
        state: null,
        countryCode: "IS",
        countryName: "Iceland",
    },
    {
        portCode: "ESZAZ",
        portName: "Zaragoza",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "THDMK",
        portName: "Don Mueang International Apt",
        state: null,
        countryCode: "TH",
        countryName: "Thailand",
    },
    {
        portCode: "KRBNP",
        portName: "Busan New Port",
        state: null,
        countryCode: "KR",
        countryName: "South Korea",
    },
    {
        portCode: "USMIT",
        portName: "Shafter",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CNWHI",
        portName: "Wuhu",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "TRISK",
        portName: "Iskenderun",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "CNURC",
        portName: "Urumqi",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USDOR",
        portName: "Dover",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ESMOA",
        portName: "Moana",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "GBSHE",
        portName: "Sheffield",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "INMDP",
        portName: "Mandapam",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "BZBZE",
        portName: "Belize City",
        state: null,
        countryCode: "BZ",
        countryName: "Belize",
    },
    {
        portCode: "AULWH",
        portName: "Lawn Hill",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "ZAELS",
        portName: "East London",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "DECRH",
        portName: "Crailsheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "USMYC",
        portName: "Mystic",
        state: "Connecticut",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRTZX",
        portName: "Trabzon",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "VNLMP",
        portName: "Vietnam Lee & Man Port",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USMFE",
        portName: "McAllen",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CRAJU",
        portName: "Alajuela",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "CRSJO",
        portName: "San Jose",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "EESLM",
        portName: "Sillamae",
        state: null,
        countryCode: "EE",
        countryName: "Estonia",
    },
    {
        portCode: "NLVEE",
        portName: "Veenendaal",
        state: null,
        countryCode: "NL",
        countryName: "Netherlands",
    },
    {
        portCode: "GBSUD",
        portName: "Sudbury",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CRPMN",
        portName: "Puerto Moin",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "TMASB",
        portName: "Ashkhabad",
        state: null,
        countryCode: "TM",
        countryName: "Turkmenistan",
    },
    {
        portCode: "ESMPG",
        portName: "Marin",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "UYPDU",
        portName: "Paysandu",
        state: null,
        countryCode: "UY",
        countryName: "Uruguay",
    },
    {
        portCode: "SNDKR",
        portName: "Dakar",
        state: null,
        countryCode: "SN",
        countryName: "Senegal",
    },
    {
        portCode: "BRPEC",
        portName: "Pecem Pt / Sao Goncalo do Amarante",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "ESVGO",
        portName: "Vigo",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "MXCUN",
        portName: "Cancun",
        state: "Quintana Roo",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "TZZNZ",
        portName: "Zanzibar",
        state: null,
        countryCode: "TZ",
        countryName: "Tanzania",
    },
    {
        portCode: "ILOME",
        portName: "'Omer",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "GBBNW",
        portName: "Burtonwood",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "BRSVT",
        portName: "Sao Vicente",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "STTMS",
        portName: "Sao Tome Island",
        state: null,
        countryCode: "ST",
        countryName: "Sao Tome and Principe",
    },
    {
        portCode: "CNQIN",
        portName: "Qingdao",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "COBGA",
        portName: "Bucaramanga",
        state: null,
        countryCode: "CO",
        countryName: "Colombia",
    },
    {
        portCode: "BRBEL",
        portName: "Belem",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "DEGRM",
        portName: "Griesheim",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "MZBEW",
        portName: "Beira",
        state: null,
        countryCode: "MZ",
        countryName: "Mozambique",
    },
    {
        portCode: "MWLLW",
        portName: "Lilongwe",
        state: null,
        countryCode: "MW",
        countryName: "Malawi",
    },
    {
        portCode: "NOKRS",
        portName: "Kristiansand",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "CNGZG",
        portName: "Guangzhou Pt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "UGEBB",
        portName: "Entebbe",
        state: null,
        countryCode: "UG",
        countryName: "Uganda",
    },
    {
        portCode: "GBWTR",
        portName: "Worcester",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "CAYMX",
        portName: "Mirabel Apt/Montreal",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "GBBBS",
        portName: "Blackbush",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "SKKSC",
        portName: "Kosice",
        state: null,
        countryCode: "SK",
        countryName: "Slovakia",
    },
    {
        portCode: "USFIL",
        portName: "Fillmore",
        state: "Utah",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMYR",
        portName: "Myrtle Beach",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CFBGF",
        portName: "Bangui",
        state: null,
        countryCode: "CF",
        countryName: "Central African Republic",
    },
    {
        portCode: "EGAKI",
        portName: "Abu Kir",
        state: null,
        countryCode: "EG",
        countryName: "Egypt",
    },
    {
        portCode: "USRCO",
        portName: "Carencro",
        state: "Louisiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "FRMTX",
        portName: "Montoir-de-Bretagne",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USFDB",
        portName: "Fredericksburg",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITARQ",
        portName: "Arquata Scrivia",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USBFA",
        portName: "Buford",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USZNE",
        portName: "Newville",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "INTRL",
        portName: "Tiruvallur",
        state: null,
        countryCode: "IN",
        countryName: "India",
    },
    {
        portCode: "USCSF",
        portName: "Carteret",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USORH",
        portName: "Worcester",
        state: "Massachusetts",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USQNH",
        portName: "Northampton",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGDA",
        portName: "Glendale",
        state: "Arizona",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ITCTA",
        portName: "Catania",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "FRLIO",
        portName: "Lyon",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "CNHNH",
        portName: "Huanghua",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "CYECN",
        portName: "Ercan Airport",
        state: null,
        countryCode: "CY",
        countryName: "Cyprus",
    },
    {
        portCode: "FR9AV",
        portName: "Vadencourt",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "BGPDV",
        portName: "Plovdiv",
        state: null,
        countryCode: "BG",
        countryName: "Bulgaria",
    },
    {
        portCode: "AUURN",
        portName: "Urangan",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "USPUQ",
        portName: "Pacoima",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CASYP",
        portName: "Stony Plain",
        state: "Alberta",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USDVM",
        portName: "Del Valle",
        state: "Texas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SRPBM",
        portName: "Paramaribo",
        state: null,
        countryCode: "SR",
        countryName: "Suriname",
    },
    {
        portCode: "FRDKK",
        portName: "Dunkerque",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "NAWVB",
        portName: "Walvis Bay",
        state: null,
        countryCode: "NA",
        countryName: "Namibia",
    },
    {
        portCode: "BRBSS",
        portName: "Balsas",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "NGABV",
        portName: "Abuja",
        state: null,
        countryCode: "NG",
        countryName: "Nigeria",
    },
    {
        portCode: "GRASS",
        portName: "Aspropirgos",
        state: null,
        countryCode: "GR",
        countryName: "Greece",
    },
    {
        portCode: "ECUIO",
        portName: "Quito",
        state: null,
        countryCode: "EC",
        countryName: "Ecuador",
    },
    {
        portCode: "KZAST",
        portName: "Astana",
        state: null,
        countryCode: "KZ",
        countryName: "Kazakhstan",
    },
    {
        portCode: "USCOI",
        portName: "Cocoa",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFEH",
        portName: "Freehold",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PLWRO",
        portName: "Wroclaw",
        state: null,
        countryCode: "PL",
        countryName: "Poland",
    },
    {
        portCode: "GMBJL",
        portName: "Banjul",
        state: null,
        countryCode: "GM",
        countryName: "Gambia",
    },
    {
        portCode: "ITFRA",
        portName: "Frascati",
        state: null,
        countryCode: "IT",
        countryName: "Italy",
    },
    {
        portCode: "USMPV",
        portName: "Barre-Montpelier Apt",
        state: "Vermont",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLLU",
        portName: "Los Lunas",
        state: "New Mexico",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "GBNCL",
        portName: "Newcastle upon Tyne",
        state: null,
        countryCode: "GB",
        countryName: "United Kingdom",
    },
    {
        portCode: "USWUH",
        portName: "White",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USGBO",
        portName: "Greensboro",
        state: "North Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPZL",
        portName: "Port Saint Lucie",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "UYPIR",
        portName: "Piriapolis",
        state: null,
        countryCode: "UY",
        countryName: "Uruguay",
    },
    {
        portCode: "MTDIS",
        portName: "Malta Freeport Distripark",
        state: null,
        countryCode: "MT",
        countryName: "Malta",
    },
    {
        portCode: "USWOR",
        portName: "West Orange/New Jersey",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MLBKO",
        portName: "Bamako",
        state: null,
        countryCode: "ML",
        countryName: "Mali",
    },
    {
        portCode: "USHST",
        portName: "Homestead",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USABA",
        portName: "Oldsmar",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "PGPOM",
        portName: "Port Moresby",
        state: null,
        countryCode: "PG",
        countryName: "Papua New Guinea",
    },
    {
        portCode: "MCMCM",
        portName: "Monte-Carlo",
        state: null,
        countryCode: "MC",
        countryName: "Monaco",
    },
    {
        portCode: "USLZC",
        portName: "Lancaster",
        state: "Minnesota",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "TRMIL",
        portName: "Milas",
        state: null,
        countryCode: "TR",
        countryName: "Turkey",
    },
    {
        portCode: "MXMTY",
        portName: "Monterrey",
        state: "Nuevo Le\u00f3n",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "DOSDQ",
        portName: "Santo Domingo",
        state: null,
        countryCode: "DO",
        countryName: "Dominican Republic",
    },
    {
        portCode: "HRDBV",
        portName: "Dubrovnik",
        state: null,
        countryCode: "HR",
        countryName: "Croatia",
    },
    {
        portCode: "BRFOR",
        portName: "Fortaleza",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "DOPUJ",
        portName: "Punta Cana Apt",
        state: null,
        countryCode: "DO",
        countryName: "Dominican Republic",
    },
    {
        portCode: "MDRMO",
        portName: "Chisinau Intl.",
        state: null,
        countryCode: "MD",
        countryName: "Moldova",
    },
    {
        portCode: "ZAPLZ",
        portName: "Port Elizabeth",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "USBOY",
        portName: "Brooklyn/New York",
        state: "New York",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "ESCAR",
        portName: "Cartagena",
        state: null,
        countryCode: "ES",
        countryName: "Spain",
    },
    {
        portCode: "CZPRB",
        portName: "Pardubice",
        state: null,
        countryCode: "CZ",
        countryName: "Czech Republic",
    },
    {
        portCode: "BE7PD",
        portName: "Athis",
        state: null,
        countryCode: "BE",
        countryName: "Belgium",
    },
    {
        portCode: "USILG",
        portName: "Wilmington",
        state: "Delaware",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SAKAC",
        portName: "King Abdullah City",
        state: null,
        countryCode: "SA",
        countryName: "Saudi Arabia",
    },
    {
        portCode: "DEHHN",
        portName: "Hahn",
        state: null,
        countryCode: "DE",
        countryName: "Germany",
    },
    {
        portCode: "CNINC",
        portName: "Yinchuan Hedong International Apt",
        state: null,
        countryCode: "CN",
        countryName: "China",
    },
    {
        portCode: "USQOA",
        portName: "Olyphant",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSGV",
        portName: "Sterling",
        state: "Virginia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USNST",
        portName: "New Stanton",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "US8GA",
        portName: "Gardiner",
        state: null,
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USMGC",
        portName: "Michigan City",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USKCR",
        portName: "Colorado Creek",
        state: "Alaska",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "SENRK",
        portName: "Norrkoping",
        state: null,
        countryCode: "SE",
        countryName: "Sweden",
    },
    {
        portCode: "BRSLF",
        portName: "Salgado Filho",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "USCLM",
        portName: "Port Angeles",
        state: "Washington",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BRPOA",
        portName: "Porto Alegre",
        state: null,
        countryCode: "BR",
        countryName: "Brazil",
    },
    {
        portCode: "GEBUS",
        portName: "Batumi",
        state: null,
        countryCode: "GE",
        countryName: "Georgia",
    },
    {
        portCode: "KHKTI",
        portName: "Kratie",
        state: null,
        countryCode: "KH",
        countryName: "Cambodia",
    },
    {
        portCode: "USPIL",
        portName: "Piscataway",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CWCUR",
        portName: "Curacao",
        state: null,
        countryCode: "CW",
        countryName: "Cura\u00e7ao",
    },
    {
        portCode: "FRORY",
        portName: "Orly Apt/Paris",
        state: null,
        countryCode: "FR",
        countryName: "France",
    },
    {
        portCode: "USVAN",
        portName: "Vancouver",
        state: "Washington",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USHQP",
        portName: "Hesperia",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "NOATL",
        portName: "Atloy",
        state: null,
        countryCode: "NO",
        countryName: "Norway",
    },
    {
        portCode: "NZMTN",
        portName: "Milton",
        state: null,
        countryCode: "NZ",
        countryName: "New Zealand",
    },
    {
        portCode: "USMIC",
        portName: "Milton",
        state: "Pennsylvania",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USLAT",
        portName: "Los Alamitos",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "VNSTR",
        portName: "ICD Sotrans",
        state: null,
        countryCode: "VN",
        countryName: "Vietnam",
    },
    {
        portCode: "USYWX",
        portName: "White",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USYIL",
        portName: "Indialantic",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CRLIO",
        portName: "Puerto Limon",
        state: null,
        countryCode: "CR",
        countryName: "Costa Rica",
    },
    {
        portCode: "PGRKU",
        portName: "Yule Island",
        state: null,
        countryCode: "PG",
        countryName: "Papua New Guinea",
    },
    {
        portCode: "USMOO",
        portName: "Moonachie/New Jersey",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USPC9",
        portName: "Park City",
        state: "Kansas",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USXFR",
        portName: "Fontana",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "CDFIH",
        portName: "Kinshasa",
        state: null,
        countryCode: "CD",
        countryName: "Congo (Kinshasa)",
    },
    {
        portCode: "AUHAT",
        portName: "Heathlands",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "GTAAZ",
        portName: "Quetzaltenango",
        state: null,
        countryCode: "GT",
        countryName: "Guatemala",
    },
    {
        portCode: "MABOS",
        portName: "Bouskoura",
        state: null,
        countryCode: "MA",
        countryName: "Morocco",
    },
    {
        portCode: "CAMOL",
        portName: "Mont-Louis",
        state: "Quebec",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "CA2SL",
        portName: "St. Louis",
        state: null,
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "MXPGO",
        portName: "Progreso",
        state: "Yucatan",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "AUTSV",
        portName: "Townsville",
        state: "Queensland",
        countryCode: "AU",
        countryName: "Australia",
    },
    {
        portCode: "JPCTS",
        portName: "Chitose Apt/Sapporo",
        state: null,
        countryCode: "JP",
        countryName: "Japan",
    },
    {
        portCode: "USNWA",
        portName: "New Albany",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BNBWN",
        portName: "Bandar Seri Begawan",
        state: null,
        countryCode: "BN",
        countryName: "Brunei",
    },
    {
        portCode: "ZAZBA",
        portName: "Coega",
        state: null,
        countryCode: "ZA",
        countryName: "South Africa",
    },
    {
        portCode: "USEWD",
        portName: "Englewood",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USWYN",
        portName: "Wayne",
        state: "New Jersey",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USSJC",
        portName: "San Jose",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BIBJM",
        portName: "Bujumbura",
        state: null,
        countryCode: "BI",
        countryName: "Burundi",
    },
    {
        portCode: "BIGID",
        portName: "Gitega",
        state: null,
        countryCode: "BI",
        countryName: "Burundi",
    },
    {
        portCode: "BIKRE",
        portName: "Kirundo",
        state: null,
        countryCode: "BI",
        countryName: "Burundi",
    },
    {
        portCode: "USUFK",
        portName: "Cartersville",
        state: "Georgia",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USFIS",
        portName: "Fountain Inn",
        state: "South Carolina",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "MXHMO",
        portName: "Hermosillo",
        state: "Sonora",
        countryCode: "MX",
        countryName: "Mexico",
    },
    {
        portCode: "TMCRZ",
        portName: "Tchardjou",
        state: null,
        countryCode: "TM",
        countryName: "Turkmenistan",
    },
    {
        portCode: "NGLKK",
        portName: "Ibeju - Lekki",
        state: null,
        countryCode: "NG",
        countryName: "Nigeria",
    },
    {
        portCode: "ILTIB",
        portName: "Tiberias",
        state: null,
        countryCode: "IL",
        countryName: "Israel",
    },
    {
        portCode: "USMEL",
        portName: "Merrillville",
        state: "Indiana",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USBHA",
        portName: "Byhalia",
        state: "Mississippi",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USTLK",
        portName: "Turlock",
        state: "California",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "USDSM",
        portName: "Des Moines",
        state: "Iowa",
        countryCode: "US",
        countryName: "United States",
    },
    {
        portCode: "BZSPR",
        portName: "San Pedro",
        state: null,
        countryCode: "BZ",
        countryName: "Belize",
    },
    {
        portCode: "CAYYL",
        portName: "Lynn Lake",
        state: "Manitoba",
        countryCode: "CA",
        countryName: "Canada",
    },
    {
        portCode: "USP2S",
        portName: "Palm Springs",
        state: "Florida",
        countryCode: "US",
        countryName: "United States",
    },
];
